/* tslint:disable */
/* eslint-disable */
/**
 * Flow Router
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface AuthorAnalysisRouterRequest
 */
export interface AuthorAnalysisRouterRequest {
    /**
     * 
     * @type {string}
     * @memberof AuthorAnalysisRouterRequest
     */
    'flow_version': string;
}
/**
 * 
 * @export
 * @interface CancelDecisionResponse
 */
export interface CancelDecisionResponse {
    /**
     * 
     * @type {string}
     * @memberof CancelDecisionResponse
     */
    'status'?: CancelDecisionResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof CancelDecisionResponse
     */
    'decision_id': string;
}

/**
    * @export
    * @enum {string}
    */
export enum CancelDecisionResponseStatusEnum {
    CANCELED = 'canceled'
}

/**
 * 
 * @export
 * @interface Data
 */
export interface Data {
    /**
     * 
     * @type {string}
     * @memberof Data
     */
    'type'?: DataTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof Data
     */
    'dataset_id': string;
    /**
     * 
     * @type {string}
     * @memberof Data
     */
    'dataset_etag': string;
    /**
     * 
     * @type {string}
     * @memberof Data
     */
    'run_id': string;
    /**
     * 
     * @type {string}
     * @memberof Data
     */
    'version_id': string;
    /**
     * 
     * @type {string}
     * @memberof Data
     */
    'node_id': string;
    /**
     * 
     * @type {string}
     * @memberof Data
     */
    'format'?: DataFormatEnum;
    /**
     * 
     * @type {number}
     * @memberof Data
     */
    'page': number;
    /**
     * 
     * @type {string}
     * @memberof Data
     */
    'status': DataStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof Data
     */
    'job_run_id': string;
}

/**
    * @export
    * @enum {string}
    */
export enum DataTypeEnum {
    OUTCOME_DATA = 'outcome_data',
    ANALYTICS = 'analytics',
    NODE_RESULT_SUMMARY = 'node_result_summary',
    NODE_RESULTS = 'node_results',
    NODE_RESULTS_PAGE = 'node_results_page',
    NODE_ANALYTICS = 'node_analytics',
    SIMULATION_ANALYTICS = 'simulation_analytics'
}
/**
    * @export
    * @enum {string}
    */
export enum DataFormatEnum {
    JSON = 'json',
    CSV = 'csv'
}
/**
    * @export
    * @enum {string}
    */
export enum DataStatusEnum {
    SUCCESS = 'success',
    SUCCESS_MATCH = 'success_match',
    SUCCESS_MISMATCH = 'success_mismatch',
    FAILURE = 'failure',
    IGNORED = 'ignored',
    ERRORS = 'errors'
}

/**
 * 
 * @export
 * @interface Data1
 */
export interface Data1 {
}
/**
 * Port from flow-api/app/flow_api/schemas
 * @export
 * @interface DataRetentionTimedelta
 */
export interface DataRetentionTimedelta {
    /**
     * 
     * @type {number}
     * @memberof DataRetentionTimedelta
     */
    'value': number;
    /**
     * 
     * @type {DataRetentionUnit}
     * @memberof DataRetentionTimedelta
     */
    'unit': DataRetentionUnit;
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum DataRetentionUnit {
    SECONDS = 'seconds',
    MINUTES = 'minutes',
    HOURS = 'hours',
    DAYS = 'days',
    WEEKS = 'weeks',
    MONTHS = 'months',
    YEARS = 'years'
}


/**
 * 
 * @export
 * @interface DecideControlV2
 */
export interface DecideControlV2 {
    /**
     * 
     * @type {ExecutionMode}
     * @memberof DecideControlV2
     */
    'execution_mode'?: ExecutionMode;
    /**
     * 
     * @type {PublishingConfiguration}
     * @memberof DecideControlV2
     */
    'publish'?: PublishingConfiguration | null;
    /**
     * 
     * @type {string}
     * @memberof DecideControlV2
     */
    'idempotency_key'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DecideControlV2
     */
    'start_node_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DecideControlV2
     */
    'sensitive_data_decryption_key'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DecideControlV2
     */
    'interruption_count'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof DecideControlV2
     */
    'force_async_retry'?: boolean | null;
    /**
     * 
     * @type {HttpPayloadV2}
     * @memberof DecideControlV2
     */
    'response'?: HttpPayloadV2 | null;
    /**
     * 
     * @type {string}
     * @memberof DecideControlV2
     */
    'flow_version_etag'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DecideControlV2
     */
    'runner_lambda_version'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DecideControlV2
     */
    'timeout'?: number | null;
}


/**
 * 
 * @export
 * @interface DecideResponse
 */
export interface DecideResponse {
    /**
     * 
     * @type {any}
     * @memberof DecideResponse
     */
    'data': any;
    /**
     * 
     * @type {string}
     * @memberof DecideResponse
     */
    'status'?: string;
    /**
     * 
     * @type {ResponseMetadata}
     * @memberof DecideResponse
     */
    'metadata': ResponseMetadata;
    /**
     * 
     * @type {Array<{ [key: string]: DecideResponseRawProviderResponsesInnerValue; }>}
     * @memberof DecideResponse
     */
    'raw_provider_responses'?: Array<{ [key: string]: DecideResponseRawProviderResponsesInnerValue; }> | null;
    /**
     * 
     * @type {Array<RawRequestDict>}
     * @memberof DecideResponse
     */
    'raw_provider_requests'?: Array<RawRequestDict> | null;
}
/**
 * 
 * @export
 * @interface DecideResponseRawProviderResponsesInnerValue
 */
export interface DecideResponseRawProviderResponsesInnerValue {
}
/**
 * 
 * @export
 * @interface DecisionHistoryIndexResponse
 */
export interface DecisionHistoryIndexResponse {
    /**
     * 
     * @type {Array<DecisionResource>}
     * @memberof DecisionHistoryIndexResponse
     */
    'decision_resources': Array<DecisionResource>;
}
/**
 * 
 * @export
 * @interface DecisionHistoryResponse
 */
export interface DecisionHistoryResponse {
    /**
     * 
     * @type {string}
     * @memberof DecisionHistoryResponse
     */
    'flow_slug': string;
    /**
     * 
     * @type {string}
     * @memberof DecisionHistoryResponse
     */
    'decision_id': string;
    /**
     * 
     * @type {string}
     * @memberof DecisionHistoryResponse
     */
    'url': string;
}
/**
 * 
 * @export
 * @interface DecisionResource
 */
export interface DecisionResource {
    /**
     * 
     * @type {string}
     * @memberof DecisionResource
     */
    'url': string;
    /**
     * 
     * @type {string}
     * @memberof DecisionResource
     */
    'date': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum ExecutionMode {
    SYNC = 'sync',
    ASYNC = 'async'
}


/**
 * 
 * @export
 * @interface FlowVersionShallow
 */
export interface FlowVersionShallow {
    /**
     * 
     * @type {string}
     * @memberof FlowVersionShallow
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof FlowVersionShallow
     */
    'url': string;
    /**
     * 
     * @type {string}
     * @memberof FlowVersionShallow
     */
    'created_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FlowVersionShallow
     */
    'updated_at'?: string | null;
    /**
     * 
     * @type {FlowVersionStatus}
     * @memberof FlowVersionShallow
     */
    'status': FlowVersionStatus;
}


/**
 * States of a flow version status
 * @export
 * @enum {string}
 */

export enum FlowVersionStatus {
    DRAFT = 'DRAFT',
    PUBLISHED = 'PUBLISHED',
    ARCHIVED = 'ARCHIVED'
}


/**
 * 
 * @export
 * @interface HTTPValidationError
 */
export interface HTTPValidationError {
    /**
     * 
     * @type {Array<ValidationError>}
     * @memberof HTTPValidationError
     */
    'detail'?: Array<ValidationError>;
}
/**
 * 
 * @export
 * @interface HttpPayloadV2
 */
export interface HttpPayloadV2 {
    /**
     * 
     * @type {number}
     * @memberof HttpPayloadV2
     */
    'status_code': number;
    /**
     * 
     * @type {string}
     * @memberof HttpPayloadV2
     */
    'body_s3_url'?: string | null;
    /**
     * 
     * @type {}
     * @memberof HttpPayloadV2
     */
    'body'?:  | null;
}
/**
 * 
 * @export
 * @interface InputSchema
 */
export interface InputSchema {
    [key: string]: any;

    /**
     * 
     * @type {Array<string>}
     * @memberof InputSchema
     */
    'required'?: Array<string>;
    /**
     * 
     * @type {object}
     * @memberof InputSchema
     */
    'properties'?: object;
    /**
     * 
     * @type {Array<string>}
     * @memberof InputSchema
     */
    'sensitive'?: Array<string>;
}
/**
 * 
 * @export
 * @interface Insights
 */
export interface Insights {
}
/**
 * 
 * @export
 * @interface JobRunRequestPostData
 */
export interface JobRunRequestPostData {
    /**
     * 
     * @type {string}
     * @memberof JobRunRequestPostData
     */
    'compressed_data': string;
}
/**
 * ML node meta schema
 * @export
 * @interface MLNodeMeta
 */
export interface MLNodeMeta {
    /**
     * 
     * @type {string}
     * @memberof MLNodeMeta
     */
    'src': string;
    /**
     * 
     * @type {string}
     * @memberof MLNodeMeta
     */
    'model_id': string | null;
    /**
     * 
     * @type {string}
     * @memberof MLNodeMeta
     */
    'model_filename': string | null;
    /**
     * 
     * @type {string}
     * @memberof MLNodeMeta
     */
    'description': string | null;
    /**
     * 
     * @type {string}
     * @memberof MLNodeMeta
     */
    'graph_name': string | null;
    /**
     * 
     * @type {string}
     * @memberof MLNodeMeta
     */
    'producer_name': string | null;
    /**
     * 
     * @type {string}
     * @memberof MLNodeMeta
     */
    'version': string | null;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof MLNodeMeta
     */
    'custom_metadata': { [key: string]: string; } | null;
    /**
     * 
     * @type {string}
     * @memberof MLNodeMeta
     */
    'author': string | null;
    /**
     * 
     * @type {string}
     * @memberof MLNodeMeta
     */
    'training_data': string | null;
    /**
     * 
     * @type {Array<MLNodeTensor>}
     * @memberof MLNodeMeta
     */
    'inputs': Array<MLNodeTensor> | null;
    /**
     * 
     * @type {Array<MLNodeTensor>}
     * @memberof MLNodeMeta
     */
    'outputs': Array<MLNodeTensor> | null;
}
/**
 * 
 * @export
 * @interface MLNodePollResult
 */
export interface MLNodePollResult {
    /**
     * 
     * @type {Result}
     * @memberof MLNodePollResult
     */
    'result': Result;
}
/**
 * 
 * @export
 * @interface MLNodePollResultFailure
 */
export interface MLNodePollResultFailure {
    /**
     * 
     * @type {string}
     * @memberof MLNodePollResultFailure
     */
    'type'?: MLNodePollResultFailureTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof MLNodePollResultFailure
     */
    'model_id': string;
    /**
     * 
     * @type {object}
     * @memberof MLNodePollResultFailure
     */
    'error': object;
}

/**
    * @export
    * @enum {string}
    */
export enum MLNodePollResultFailureTypeEnum {
    ERROR = 'error'
}

/**
 * 
 * @export
 * @interface MLNodePollResultPending
 */
export interface MLNodePollResultPending {
    /**
     * 
     * @type {string}
     * @memberof MLNodePollResultPending
     */
    'type'?: MLNodePollResultPendingTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof MLNodePollResultPending
     */
    'model_id': string;
}

/**
    * @export
    * @enum {string}
    */
export enum MLNodePollResultPendingTypeEnum {
    PENDING = 'pending'
}

/**
 * 
 * @export
 * @interface MLNodePollResultSuccess
 */
export interface MLNodePollResultSuccess {
    /**
     * 
     * @type {string}
     * @memberof MLNodePollResultSuccess
     */
    'type'?: MLNodePollResultSuccessTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof MLNodePollResultSuccess
     */
    'model_id': string;
    /**
     * 
     * @type {MLNodeMeta}
     * @memberof MLNodePollResultSuccess
     */
    'metadata': MLNodeMeta;
}

/**
    * @export
    * @enum {string}
    */
export enum MLNodePollResultSuccessTypeEnum {
    SUCCESS = 'success'
}

/**
 * ML node tensor schema
 * @export
 * @interface MLNodeTensor
 */
export interface MLNodeTensor {
    /**
     * 
     * @type {string}
     * @memberof MLNodeTensor
     */
    'name': string;
    /**
     * 
     * @type {Array<number | null>}
     * @memberof MLNodeTensor
     */
    'shape': Array<number | null>;
    /**
     * 
     * @type {string}
     * @memberof MLNodeTensor
     */
    'dtype': string;
}
/**
 * 
 * @export
 * @interface MLNodeUploadResponse
 */
export interface MLNodeUploadResponse {
    /**
     * 
     * @type {string}
     * @memberof MLNodeUploadResponse
     */
    'url': string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof MLNodeUploadResponse
     */
    'fields': { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof MLNodeUploadResponse
     */
    'model_id': string;
}
/**
 * 
 * @export
 * @interface OutputSchema
 */
export interface OutputSchema {
    [key: string]: any;

    /**
     * 
     * @type {Array<string>}
     * @memberof OutputSchema
     */
    'required'?: Array<string>;
    /**
     * 
     * @type {object}
     * @memberof OutputSchema
     */
    'properties'?: object;
}
/**
 * 
 * @export
 * @interface Parameters
 */
export interface Parameters {
    /**
     * 
     * @type {string}
     * @memberof Parameters
     */
    'name': string;
    /**
     * 
     * @type {any}
     * @memberof Parameters
     */
    'value': any;
    /**
     * 
     * @type {string}
     * @memberof Parameters
     */
    'description'?: string | null;
}
/**
 * 
 * @export
 * @interface PreSignedUrlResponse
 */
export interface PreSignedUrlResponse {
    /**
     * 
     * @type {string}
     * @memberof PreSignedUrlResponse
     */
    'url': string;
}
/**
 * 
 * @export
 * @interface ProviderResourceRawRequestDict
 */
export interface ProviderResourceRawRequestDict {
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ProviderResourceRawRequestDict
     */
    'headers': { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof ProviderResourceRawRequestDict
     */
    'body': string | null;
    /**
     * 
     * @type {string}
     * @memberof ProviderResourceRawRequestDict
     */
    'method': string;
    /**
     * 
     * @type {string}
     * @memberof ProviderResourceRawRequestDict
     */
    'url': string;
}
/**
 * Used in the endpoints exposed directly to customers.  Exercise caution when modifying this schema and ensure the no breaking changes are introduced.
 * @export
 * @interface PublicFlowVersion
 */
export interface PublicFlowVersion {
    /**
     * 
     * @type {string}
     * @memberof PublicFlowVersion
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PublicFlowVersion
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof PublicFlowVersion
     */
    'etag': string;
    /**
     * 
     * @type {object}
     * @memberof PublicFlowVersion
     */
    'graph'?: object | null;
    /**
     * 
     * @type {Array<Parameters>}
     * @memberof PublicFlowVersion
     */
    'parameters'?: Array<Parameters> | null;
    /**
     * 
     * @type {InputSchema}
     * @memberof PublicFlowVersion
     */
    'input_schema'?: InputSchema | null;
    /**
     * 
     * @type {OutputSchema}
     * @memberof PublicFlowVersion
     */
    'output_schema'?: OutputSchema | null;
    /**
     * 
     * @type {FlowVersionStatus}
     * @memberof PublicFlowVersion
     */
    'status': FlowVersionStatus;
    /**
     * 
     * @type {Array<PublicFlowVersion>}
     * @memberof PublicFlowVersion
     */
    'child_versions'?: Array<PublicFlowVersion> | null;
    /**
     * 
     * @type {string}
     * @memberof PublicFlowVersion
     */
    'created_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PublicFlowVersion
     */
    'updated_at'?: string | null;
}


/**
 * 
 * @export
 * @interface PublishingConfiguration
 */
export interface PublishingConfiguration {
    /**
     * 
     * @type {Array<string>}
     * @memberof PublishingConfiguration
     */
    'events'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof PublishingConfiguration
     */
    'entities'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface RawRequestDict
 */
export interface RawRequestDict {
    /**
     * 
     * @type {string}
     * @memberof RawRequestDict
     */
    'provider': string;
    /**
     * 
     * @type {string}
     * @memberof RawRequestDict
     */
    'resource': string;
    /**
     * 
     * @type {string}
     * @memberof RawRequestDict
     */
    'node_id': string;
    /**
     * 
     * @type {string}
     * @memberof RawRequestDict
     */
    'node_name': string;
    /**
     * 
     * @type {string}
     * @memberof RawRequestDict
     */
    'resource_config_id': string;
    /**
     * 
     * @type {ProviderResourceRawRequestDict}
     * @memberof RawRequestDict
     */
    'raw_request': ProviderResourceRawRequestDict;
}
/**
 * 
 * @export
 * @interface RequestMetadata
 */
export interface RequestMetadata {
    /**
     * 
     * @type {string}
     * @memberof RequestMetadata
     */
    'environment'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RequestMetadata
     */
    'version'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RequestMetadata
     */
    'entity_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RequestMetadata
     */
    'timestamp'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RequestMetadata
     */
    'decision_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RequestMetadata
     */
    'decision_url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RequestMetadata
     */
    'flow_slug'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof RequestMetadata
     */
    'is_internal'?: boolean;
}
/**
 * 
 * @export
 * @interface ResponseMetadata
 */
export interface ResponseMetadata {
    /**
     * 
     * @type {string}
     * @memberof ResponseMetadata
     */
    'environment'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponseMetadata
     */
    'version'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponseMetadata
     */
    'entity_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponseMetadata
     */
    'timestamp'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponseMetadata
     */
    'decision_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponseMetadata
     */
    'decision_url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponseMetadata
     */
    'flow_slug'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponseMetadata
     */
    'traffic_policy'?: string | null;
}
/**
 * @type Result
 * @export
 */
export type Result = { type: 'error' } & MLNodePollResultFailure | { type: 'pending' } & MLNodePollResultPending | { type: 'success' } & MLNodePollResultSuccess;

/**
 * 
 * @export
 * @interface SandboxDecideRequest
 */
export interface SandboxDecideRequest {
    /**
     * 
     * @type {object}
     * @memberof SandboxDecideRequest
     */
    'data'?: object | null;
    /**
     * 
     * @type {object}
     * @memberof SandboxDecideRequest
     */
    'features'?: object | null;
    /**
     * 
     * @type {RequestMetadata}
     * @memberof SandboxDecideRequest
     */
    'metadata': RequestMetadata;
    /**
     * 
     * @type {DecideControlV2}
     * @memberof SandboxDecideRequest
     */
    'control'?: DecideControlV2;
    /**
     * 
     * @type {{ [key: string]: SandboxDecideRequestMockDataValue; }}
     * @memberof SandboxDecideRequest
     */
    'mock_data'?: { [key: string]: SandboxDecideRequestMockDataValue; } | null;
}
/**
 * 
 * @export
 * @interface SandboxDecideRequestMockDataValue
 */
export interface SandboxDecideRequestMockDataValue {
    /**
     * 
     * @type {Data1}
     * @memberof SandboxDecideRequestMockDataValue
     */
    'data'?: Data1;
    /**
     * 
     * @type {Insights}
     * @memberof SandboxDecideRequestMockDataValue
     */
    'insights'?: Insights;
}
/**
 * 
 * @export
 * @interface SandboxMockData
 */
export interface SandboxMockData {
    [key: string]: any;

    /**
     * 
     * @type {Data1}
     * @memberof SandboxMockData
     */
    'data'?: Data1;
    /**
     * 
     * @type {Insights}
     * @memberof SandboxMockData
     */
    'insights'?: Insights;
}
/**
 * 
 * @export
 * @interface ServiceInfraMetadata
 */
export interface ServiceInfraMetadata {
    /**
     * 
     * @type {string}
     * @memberof ServiceInfraMetadata
     */
    'region': string;
    /**
     * 
     * @type {string}
     * @memberof ServiceInfraMetadata
     */
    'stack_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServiceInfraMetadata
     */
    'flow_services_version': string;
    /**
     * 
     * @type {string}
     * @memberof ServiceInfraMetadata
     */
    'function_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServiceInfraMetadata
     */
    'log_group_name'?: string | null;
    /**
     * 
     * @type {WorkspaceSettings}
     * @memberof ServiceInfraMetadata
     */
    'settings': WorkspaceSettings;
    /**
     * 
     * @type {string}
     * @memberof ServiceInfraMetadata
     */
    'error_log_insights_query_link'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServiceInfraMetadata
     */
    'last_updated_at'?: string | null;
}
/**
 * 
 * @export
 * @interface SimulationAnalyticsPresignedRequest
 */
export interface SimulationAnalyticsPresignedRequest {
    /**
     * 
     * @type {string}
     * @memberof SimulationAnalyticsPresignedRequest
     */
    'type'?: SimulationAnalyticsPresignedRequestTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SimulationAnalyticsPresignedRequest
     */
    'job_run_id': string;
}

/**
    * @export
    * @enum {string}
    */
export enum SimulationAnalyticsPresignedRequestTypeEnum {
    SIMULATION_ANALYTICS = 'simulation_analytics'
}

/**
 * 
 * @export
 * @interface TestRunAnalyticsPresignedRequest
 */
export interface TestRunAnalyticsPresignedRequest {
    /**
     * 
     * @type {string}
     * @memberof TestRunAnalyticsPresignedRequest
     */
    'type'?: TestRunAnalyticsPresignedRequestTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum TestRunAnalyticsPresignedRequestTypeEnum {
    ANALYTICS = 'analytics'
}

/**
 * Request body of a test run
 * @export
 * @interface TestRunCreate
 */
export interface TestRunCreate {
    /**
     * 
     * @type {string}
     * @memberof TestRunCreate
     */
    'dataset_id': string;
    /**
     * 
     * @type {Array<TestRunFlowVersionInput>}
     * @memberof TestRunCreate
     */
    'flow_versions': Array<TestRunFlowVersionInput>;
    /**
     * 
     * @type {string}
     * @memberof TestRunCreate
     */
    'flow_id': string;
    /**
     * 
     * @type {string}
     * @memberof TestRunCreate
     */
    'flow_slug': string;
}
/**
 * 
 * @export
 * @interface TestRunDatasetResponse
 */
export interface TestRunDatasetResponse {
    /**
     * 
     * @type {string}
     * @memberof TestRunDatasetResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TestRunDatasetResponse
     */
    'etag': string;
    /**
     * 
     * @type {number}
     * @memberof TestRunDatasetResponse
     */
    'shard_count': number;
}
/**
 * 
 * @export
 * @interface TestRunFlowVersionInput
 */
export interface TestRunFlowVersionInput {
    /**
     * 
     * @type {string}
     * @memberof TestRunFlowVersionInput
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TestRunFlowVersionInput
     */
    'etag': string;
    /**
     * 
     * @type {Array<TestRunFlowVersionInput>}
     * @memberof TestRunFlowVersionInput
     */
    'children'?: Array<TestRunFlowVersionInput> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof TestRunFlowVersionInput
     */
    'nodes_with_charts'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface TestRunFlowVersionOutput
 */
export interface TestRunFlowVersionOutput {
    /**
     * 
     * @type {string}
     * @memberof TestRunFlowVersionOutput
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TestRunFlowVersionOutput
     */
    'etag': string;
    /**
     * 
     * @type {Array<TestRunFlowVersionOutput>}
     * @memberof TestRunFlowVersionOutput
     */
    'children'?: Array<TestRunFlowVersionOutput> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof TestRunFlowVersionOutput
     */
    'nodes_with_charts'?: Array<string> | null;
}
/**
 * Backend polls for execution results on S3
 * @export
 * @interface TestRunFlowVersionWithResults
 */
export interface TestRunFlowVersionWithResults {
    /**
     * 
     * @type {string}
     * @memberof TestRunFlowVersionWithResults
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TestRunFlowVersionWithResults
     */
    'etag': string;
    /**
     * 
     * @type {Array<TestRunFlowVersionOutput>}
     * @memberof TestRunFlowVersionWithResults
     */
    'children'?: Array<TestRunFlowVersionOutput> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof TestRunFlowVersionWithResults
     */
    'nodes_with_charts'?: Array<string> | null;
    /**
     * 
     * @type {object}
     * @memberof TestRunFlowVersionWithResults
     */
    'execution_results': object | null;
    /**
     * 
     * @type {TestRunProgress}
     * @memberof TestRunFlowVersionWithResults
     */
    'progress'?: TestRunProgress | null;
}
/**
 * 
 * @export
 * @interface TestRunNodeAnalyticsPresignedRequest
 */
export interface TestRunNodeAnalyticsPresignedRequest {
    /**
     * 
     * @type {string}
     * @memberof TestRunNodeAnalyticsPresignedRequest
     */
    'type'?: TestRunNodeAnalyticsPresignedRequestTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof TestRunNodeAnalyticsPresignedRequest
     */
    'run_id': string;
    /**
     * 
     * @type {string}
     * @memberof TestRunNodeAnalyticsPresignedRequest
     */
    'version_id': string;
    /**
     * 
     * @type {string}
     * @memberof TestRunNodeAnalyticsPresignedRequest
     */
    'node_id': string;
}

/**
    * @export
    * @enum {string}
    */
export enum TestRunNodeAnalyticsPresignedRequestTypeEnum {
    NODE_ANALYTICS = 'node_analytics'
}

/**
 * 
 * @export
 * @interface TestRunOutcomeDataPresignedRequest
 */
export interface TestRunOutcomeDataPresignedRequest {
    /**
     * 
     * @type {string}
     * @memberof TestRunOutcomeDataPresignedRequest
     */
    'type'?: TestRunOutcomeDataPresignedRequestTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof TestRunOutcomeDataPresignedRequest
     */
    'dataset_id': string;
    /**
     * 
     * @type {string}
     * @memberof TestRunOutcomeDataPresignedRequest
     */
    'dataset_etag': string;
}

/**
    * @export
    * @enum {string}
    */
export enum TestRunOutcomeDataPresignedRequestTypeEnum {
    OUTCOME_DATA = 'outcome_data'
}

/**
 * 
 * @export
 * @interface TestRunProgress
 */
export interface TestRunProgress {
    /**
     * 
     * @type {number}
     * @memberof TestRunProgress
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof TestRunProgress
     */
    'successful': number;
    /**
     * 
     * @type {number}
     * @memberof TestRunProgress
     */
    'failed': number;
    /**
     * 
     * @type {number}
     * @memberof TestRunProgress
     */
    'ignored': number;
    /**
     * 
     * @type {number}
     * @memberof TestRunProgress
     */
    'output_mismatch': number;
}
/**
 * 
 * @export
 * @interface TestRunResponse
 */
export interface TestRunResponse {
    /**
     * 
     * @type {string}
     * @memberof TestRunResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TestRunResponse
     */
    'created_by': string;
    /**
     * 
     * @type {string}
     * @memberof TestRunResponse
     */
    'created_at': string;
    /**
     * 
     * @type {TestRunDatasetResponse}
     * @memberof TestRunResponse
     */
    'dataset': TestRunDatasetResponse;
    /**
     * 
     * @type {Array<TestRunFlowVersionWithResults>}
     * @memberof TestRunResponse
     */
    'flow_versions': Array<TestRunFlowVersionWithResults>;
}
/**
 * 
 * @export
 * @interface TestRunVersionNodeResultSummaryPresignedRequest
 */
export interface TestRunVersionNodeResultSummaryPresignedRequest {
    /**
     * 
     * @type {string}
     * @memberof TestRunVersionNodeResultSummaryPresignedRequest
     */
    'type'?: TestRunVersionNodeResultSummaryPresignedRequestTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof TestRunVersionNodeResultSummaryPresignedRequest
     */
    'run_id': string;
    /**
     * 
     * @type {string}
     * @memberof TestRunVersionNodeResultSummaryPresignedRequest
     */
    'version_id': string;
    /**
     * 
     * @type {string}
     * @memberof TestRunVersionNodeResultSummaryPresignedRequest
     */
    'node_id': string;
}

/**
    * @export
    * @enum {string}
    */
export enum TestRunVersionNodeResultSummaryPresignedRequestTypeEnum {
    NODE_RESULT_SUMMARY = 'node_result_summary'
}

/**
 * 
 * @export
 * @interface TestRunVersionNodeResultsPagePresignedRequest
 */
export interface TestRunVersionNodeResultsPagePresignedRequest {
    /**
     * 
     * @type {string}
     * @memberof TestRunVersionNodeResultsPagePresignedRequest
     */
    'type'?: TestRunVersionNodeResultsPagePresignedRequestTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof TestRunVersionNodeResultsPagePresignedRequest
     */
    'run_id': string;
    /**
     * 
     * @type {string}
     * @memberof TestRunVersionNodeResultsPagePresignedRequest
     */
    'version_id': string;
    /**
     * 
     * @type {string}
     * @memberof TestRunVersionNodeResultsPagePresignedRequest
     */
    'node_id': string;
    /**
     * 
     * @type {number}
     * @memberof TestRunVersionNodeResultsPagePresignedRequest
     */
    'page': number;
    /**
     * 
     * @type {string}
     * @memberof TestRunVersionNodeResultsPagePresignedRequest
     */
    'status': TestRunVersionNodeResultsPagePresignedRequestStatusEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum TestRunVersionNodeResultsPagePresignedRequestTypeEnum {
    NODE_RESULTS_PAGE = 'node_results_page'
}
/**
    * @export
    * @enum {string}
    */
export enum TestRunVersionNodeResultsPagePresignedRequestStatusEnum {
    SUCCESS = 'success',
    SUCCESS_MATCH = 'success_match',
    SUCCESS_MISMATCH = 'success_mismatch',
    FAILURE = 'failure',
    IGNORED = 'ignored',
    ERRORS = 'errors'
}

/**
 * 
 * @export
 * @interface TestRunVersionNodeResultsPresignedRequest
 */
export interface TestRunVersionNodeResultsPresignedRequest {
    /**
     * 
     * @type {string}
     * @memberof TestRunVersionNodeResultsPresignedRequest
     */
    'type'?: TestRunVersionNodeResultsPresignedRequestTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof TestRunVersionNodeResultsPresignedRequest
     */
    'run_id': string;
    /**
     * 
     * @type {string}
     * @memberof TestRunVersionNodeResultsPresignedRequest
     */
    'version_id': string;
    /**
     * 
     * @type {string}
     * @memberof TestRunVersionNodeResultsPresignedRequest
     */
    'node_id': string;
    /**
     * 
     * @type {string}
     * @memberof TestRunVersionNodeResultsPresignedRequest
     */
    'format'?: TestRunVersionNodeResultsPresignedRequestFormatEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum TestRunVersionNodeResultsPresignedRequestTypeEnum {
    NODE_RESULTS = 'node_results'
}
/**
    * @export
    * @enum {string}
    */
export enum TestRunVersionNodeResultsPresignedRequestFormatEnum {
    JSON = 'json',
    CSV = 'csv'
}

/**
 * 
 * @export
 * @interface ValidationError
 */
export interface ValidationError {
    /**
     * 
     * @type {Array<ValidationErrorLocInner>}
     * @memberof ValidationError
     */
    'loc': Array<ValidationErrorLocInner>;
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    'msg': string;
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    'type': string;
}
/**
 * 
 * @export
 * @interface ValidationErrorLocInner
 */
export interface ValidationErrorLocInner {
}
/**
 * 
 * @export
 * @interface WarmupRequest
 */
export interface WarmupRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof WarmupRequest
     */
    'flow_version_ids': Array<string>;
}
/**
 * 
 * @export
 * @interface WorkspaceSettings
 */
export interface WorkspaceSettings {
    /**
     * 
     * @type {string}
     * @memberof WorkspaceSettings
     */
    'created_by'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceSettings
     */
    'created_at'?: string | null;
    /**
     * 
     * @type {DataRetentionTimedelta}
     * @memberof WorkspaceSettings
     */
    'data_retention'?: DataRetentionTimedelta | null;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceSettings
     */
    'data_wiping_enabled_until'?: string | null;
}

/**
 * DecisionApi - axios parameter creator
 * @export
 */
export const DecisionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Cancel Pending Decision
         * @param {string} flowSlug 
         * @param {string} decisionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelPendingDecisionRunApiV1FlowsFlowSlugDecideDecisionIdCancelPost: async (flowSlug: string, decisionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'flowSlug' is not null or undefined
            assertParamExists('cancelPendingDecisionRunApiV1FlowsFlowSlugDecideDecisionIdCancelPost', 'flowSlug', flowSlug)
            // verify required parameter 'decisionId' is not null or undefined
            assertParamExists('cancelPendingDecisionRunApiV1FlowsFlowSlugDecideDecisionIdCancelPost', 'decisionId', decisionId)
            const localVarPath = `/run/api/v1/flows/{flow_slug}/decide/{decision_id}/cancel`
                .replace(`{${"flow_slug"}}`, encodeURIComponent(String(flowSlug)))
                .replace(`{${"decision_id"}}`, encodeURIComponent(String(decisionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Cancel Pending Decision Sandbox
         * @param {string} flowSlug 
         * @param {string} decisionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelPendingDecisionSandboxRunApiV1FlowsFlowSlugSandboxDecideDecisionIdCancelPost: async (flowSlug: string, decisionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'flowSlug' is not null or undefined
            assertParamExists('cancelPendingDecisionSandboxRunApiV1FlowsFlowSlugSandboxDecideDecisionIdCancelPost', 'flowSlug', flowSlug)
            // verify required parameter 'decisionId' is not null or undefined
            assertParamExists('cancelPendingDecisionSandboxRunApiV1FlowsFlowSlugSandboxDecideDecisionIdCancelPost', 'decisionId', decisionId)
            const localVarPath = `/run/api/v1/flows/{flow_slug}/sandbox/decide/{decision_id}/cancel`
                .replace(`{${"flow_slug"}}`, encodeURIComponent(String(flowSlug)))
                .replace(`{${"decision_id"}}`, encodeURIComponent(String(decisionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Post Decide
         * @param {string} flowSlug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDecideRunApiV1FlowsFlowSlugDecidePost: async (flowSlug: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'flowSlug' is not null or undefined
            assertParamExists('postDecideRunApiV1FlowsFlowSlugDecidePost', 'flowSlug', flowSlug)
            const localVarPath = `/run/api/v1/flows/{flow_slug}/decide`
                .replace(`{${"flow_slug"}}`, encodeURIComponent(String(flowSlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Post Sandbox Decide
         * @param {string} flowSlug 
         * @param {SandboxDecideRequest} sandboxDecideRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postSandboxDecideRunApiV1FlowsFlowSlugSandboxDecidePost: async (flowSlug: string, sandboxDecideRequest: SandboxDecideRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'flowSlug' is not null or undefined
            assertParamExists('postSandboxDecideRunApiV1FlowsFlowSlugSandboxDecidePost', 'flowSlug', flowSlug)
            // verify required parameter 'sandboxDecideRequest' is not null or undefined
            assertParamExists('postSandboxDecideRunApiV1FlowsFlowSlugSandboxDecidePost', 'sandboxDecideRequest', sandboxDecideRequest)
            const localVarPath = `/run/api/v1/flows/{flow_slug}/sandbox/decide`
                .replace(`{${"flow_slug"}}`, encodeURIComponent(String(flowSlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sandboxDecideRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DecisionApi - functional programming interface
 * @export
 */
export const DecisionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DecisionApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Cancel Pending Decision
         * @param {string} flowSlug 
         * @param {string} decisionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelPendingDecisionRunApiV1FlowsFlowSlugDecideDecisionIdCancelPost(flowSlug: string, decisionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CancelDecisionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelPendingDecisionRunApiV1FlowsFlowSlugDecideDecisionIdCancelPost(flowSlug, decisionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DecisionApi.cancelPendingDecisionRunApiV1FlowsFlowSlugDecideDecisionIdCancelPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Cancel Pending Decision Sandbox
         * @param {string} flowSlug 
         * @param {string} decisionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelPendingDecisionSandboxRunApiV1FlowsFlowSlugSandboxDecideDecisionIdCancelPost(flowSlug: string, decisionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CancelDecisionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelPendingDecisionSandboxRunApiV1FlowsFlowSlugSandboxDecideDecisionIdCancelPost(flowSlug, decisionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DecisionApi.cancelPendingDecisionSandboxRunApiV1FlowsFlowSlugSandboxDecideDecisionIdCancelPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Post Decide
         * @param {string} flowSlug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postDecideRunApiV1FlowsFlowSlugDecidePost(flowSlug: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DecideResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postDecideRunApiV1FlowsFlowSlugDecidePost(flowSlug, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DecisionApi.postDecideRunApiV1FlowsFlowSlugDecidePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Post Sandbox Decide
         * @param {string} flowSlug 
         * @param {SandboxDecideRequest} sandboxDecideRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postSandboxDecideRunApiV1FlowsFlowSlugSandboxDecidePost(flowSlug: string, sandboxDecideRequest: SandboxDecideRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DecideResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postSandboxDecideRunApiV1FlowsFlowSlugSandboxDecidePost(flowSlug, sandboxDecideRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DecisionApi.postSandboxDecideRunApiV1FlowsFlowSlugSandboxDecidePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DecisionApi - factory interface
 * @export
 */
export const DecisionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DecisionApiFp(configuration)
    return {
        /**
         * 
         * @summary Cancel Pending Decision
         * @param {DecisionApiCancelPendingDecisionRunApiV1FlowsFlowSlugDecideDecisionIdCancelPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelPendingDecisionRunApiV1FlowsFlowSlugDecideDecisionIdCancelPost(requestParameters: DecisionApiCancelPendingDecisionRunApiV1FlowsFlowSlugDecideDecisionIdCancelPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<CancelDecisionResponse> {
            return localVarFp.cancelPendingDecisionRunApiV1FlowsFlowSlugDecideDecisionIdCancelPost(requestParameters.flowSlug, requestParameters.decisionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Cancel Pending Decision Sandbox
         * @param {DecisionApiCancelPendingDecisionSandboxRunApiV1FlowsFlowSlugSandboxDecideDecisionIdCancelPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelPendingDecisionSandboxRunApiV1FlowsFlowSlugSandboxDecideDecisionIdCancelPost(requestParameters: DecisionApiCancelPendingDecisionSandboxRunApiV1FlowsFlowSlugSandboxDecideDecisionIdCancelPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<CancelDecisionResponse> {
            return localVarFp.cancelPendingDecisionSandboxRunApiV1FlowsFlowSlugSandboxDecideDecisionIdCancelPost(requestParameters.flowSlug, requestParameters.decisionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Post Decide
         * @param {DecisionApiPostDecideRunApiV1FlowsFlowSlugDecidePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDecideRunApiV1FlowsFlowSlugDecidePost(requestParameters: DecisionApiPostDecideRunApiV1FlowsFlowSlugDecidePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DecideResponse> {
            return localVarFp.postDecideRunApiV1FlowsFlowSlugDecidePost(requestParameters.flowSlug, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Post Sandbox Decide
         * @param {DecisionApiPostSandboxDecideRunApiV1FlowsFlowSlugSandboxDecidePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postSandboxDecideRunApiV1FlowsFlowSlugSandboxDecidePost(requestParameters: DecisionApiPostSandboxDecideRunApiV1FlowsFlowSlugSandboxDecidePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DecideResponse> {
            return localVarFp.postSandboxDecideRunApiV1FlowsFlowSlugSandboxDecidePost(requestParameters.flowSlug, requestParameters.sandboxDecideRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for cancelPendingDecisionRunApiV1FlowsFlowSlugDecideDecisionIdCancelPost operation in DecisionApi.
 * @export
 * @interface DecisionApiCancelPendingDecisionRunApiV1FlowsFlowSlugDecideDecisionIdCancelPostRequest
 */
export interface DecisionApiCancelPendingDecisionRunApiV1FlowsFlowSlugDecideDecisionIdCancelPostRequest {
    /**
     * 
     * @type {string}
     * @memberof DecisionApiCancelPendingDecisionRunApiV1FlowsFlowSlugDecideDecisionIdCancelPost
     */
    readonly flowSlug: string

    /**
     * 
     * @type {string}
     * @memberof DecisionApiCancelPendingDecisionRunApiV1FlowsFlowSlugDecideDecisionIdCancelPost
     */
    readonly decisionId: string
}

/**
 * Request parameters for cancelPendingDecisionSandboxRunApiV1FlowsFlowSlugSandboxDecideDecisionIdCancelPost operation in DecisionApi.
 * @export
 * @interface DecisionApiCancelPendingDecisionSandboxRunApiV1FlowsFlowSlugSandboxDecideDecisionIdCancelPostRequest
 */
export interface DecisionApiCancelPendingDecisionSandboxRunApiV1FlowsFlowSlugSandboxDecideDecisionIdCancelPostRequest {
    /**
     * 
     * @type {string}
     * @memberof DecisionApiCancelPendingDecisionSandboxRunApiV1FlowsFlowSlugSandboxDecideDecisionIdCancelPost
     */
    readonly flowSlug: string

    /**
     * 
     * @type {string}
     * @memberof DecisionApiCancelPendingDecisionSandboxRunApiV1FlowsFlowSlugSandboxDecideDecisionIdCancelPost
     */
    readonly decisionId: string
}

/**
 * Request parameters for postDecideRunApiV1FlowsFlowSlugDecidePost operation in DecisionApi.
 * @export
 * @interface DecisionApiPostDecideRunApiV1FlowsFlowSlugDecidePostRequest
 */
export interface DecisionApiPostDecideRunApiV1FlowsFlowSlugDecidePostRequest {
    /**
     * 
     * @type {string}
     * @memberof DecisionApiPostDecideRunApiV1FlowsFlowSlugDecidePost
     */
    readonly flowSlug: string
}

/**
 * Request parameters for postSandboxDecideRunApiV1FlowsFlowSlugSandboxDecidePost operation in DecisionApi.
 * @export
 * @interface DecisionApiPostSandboxDecideRunApiV1FlowsFlowSlugSandboxDecidePostRequest
 */
export interface DecisionApiPostSandboxDecideRunApiV1FlowsFlowSlugSandboxDecidePostRequest {
    /**
     * 
     * @type {string}
     * @memberof DecisionApiPostSandboxDecideRunApiV1FlowsFlowSlugSandboxDecidePost
     */
    readonly flowSlug: string

    /**
     * 
     * @type {SandboxDecideRequest}
     * @memberof DecisionApiPostSandboxDecideRunApiV1FlowsFlowSlugSandboxDecidePost
     */
    readonly sandboxDecideRequest: SandboxDecideRequest
}

/**
 * DecisionApi - object-oriented interface
 * @export
 * @class DecisionApi
 * @extends {BaseAPI}
 */
export class DecisionApi extends BaseAPI {
    /**
     * 
     * @summary Cancel Pending Decision
     * @param {DecisionApiCancelPendingDecisionRunApiV1FlowsFlowSlugDecideDecisionIdCancelPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DecisionApi
     */
    public cancelPendingDecisionRunApiV1FlowsFlowSlugDecideDecisionIdCancelPost(requestParameters: DecisionApiCancelPendingDecisionRunApiV1FlowsFlowSlugDecideDecisionIdCancelPostRequest, options?: RawAxiosRequestConfig) {
        return DecisionApiFp(this.configuration).cancelPendingDecisionRunApiV1FlowsFlowSlugDecideDecisionIdCancelPost(requestParameters.flowSlug, requestParameters.decisionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Cancel Pending Decision Sandbox
     * @param {DecisionApiCancelPendingDecisionSandboxRunApiV1FlowsFlowSlugSandboxDecideDecisionIdCancelPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DecisionApi
     */
    public cancelPendingDecisionSandboxRunApiV1FlowsFlowSlugSandboxDecideDecisionIdCancelPost(requestParameters: DecisionApiCancelPendingDecisionSandboxRunApiV1FlowsFlowSlugSandboxDecideDecisionIdCancelPostRequest, options?: RawAxiosRequestConfig) {
        return DecisionApiFp(this.configuration).cancelPendingDecisionSandboxRunApiV1FlowsFlowSlugSandboxDecideDecisionIdCancelPost(requestParameters.flowSlug, requestParameters.decisionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Post Decide
     * @param {DecisionApiPostDecideRunApiV1FlowsFlowSlugDecidePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DecisionApi
     */
    public postDecideRunApiV1FlowsFlowSlugDecidePost(requestParameters: DecisionApiPostDecideRunApiV1FlowsFlowSlugDecidePostRequest, options?: RawAxiosRequestConfig) {
        return DecisionApiFp(this.configuration).postDecideRunApiV1FlowsFlowSlugDecidePost(requestParameters.flowSlug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Post Sandbox Decide
     * @param {DecisionApiPostSandboxDecideRunApiV1FlowsFlowSlugSandboxDecidePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DecisionApi
     */
    public postSandboxDecideRunApiV1FlowsFlowSlugSandboxDecidePost(requestParameters: DecisionApiPostSandboxDecideRunApiV1FlowsFlowSlugSandboxDecidePostRequest, options?: RawAxiosRequestConfig) {
        return DecisionApiFp(this.configuration).postSandboxDecideRunApiV1FlowsFlowSlugSandboxDecidePost(requestParameters.flowSlug, requestParameters.sandboxDecideRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Analyze
         * @param {string} flowSlug 
         * @param {AuthorAnalysisRouterRequest} authorAnalysisRouterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyzeRunApiV1FlowsFlowSlugAuthorAnalyzePost: async (flowSlug: string, authorAnalysisRouterRequest: AuthorAnalysisRouterRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'flowSlug' is not null or undefined
            assertParamExists('analyzeRunApiV1FlowsFlowSlugAuthorAnalyzePost', 'flowSlug', flowSlug)
            // verify required parameter 'authorAnalysisRouterRequest' is not null or undefined
            assertParamExists('analyzeRunApiV1FlowsFlowSlugAuthorAnalyzePost', 'authorAnalysisRouterRequest', authorAnalysisRouterRequest)
            const localVarPath = `/run/api/v1/flows/{flow_slug}/author/analyze`
                .replace(`{${"flow_slug"}}`, encodeURIComponent(String(flowSlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(authorAnalysisRouterRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Decision By Id
         * @param {string} flowSlug 
         * @param {string} decisionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        decisionByIdRunApiV1FlowsFlowSlugDecisionsDecisionIdGet: async (flowSlug: string, decisionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'flowSlug' is not null or undefined
            assertParamExists('decisionByIdRunApiV1FlowsFlowSlugDecisionsDecisionIdGet', 'flowSlug', flowSlug)
            // verify required parameter 'decisionId' is not null or undefined
            assertParamExists('decisionByIdRunApiV1FlowsFlowSlugDecisionsDecisionIdGet', 'decisionId', decisionId)
            const localVarPath = `/run/api/v1/flows/{flow_slug}/decisions/{decision_id}`
                .replace(`{${"flow_slug"}}`, encodeURIComponent(String(flowSlug)))
                .replace(`{${"decision_id"}}`, encodeURIComponent(String(decisionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Decision Index By Version
         * @param {string} flowSlug 
         * @param {string} flowVersionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        decisionIndexByVersionRunApiV1FlowsFlowSlugDecisionsIndexFlowVersionIdGet: async (flowSlug: string, flowVersionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'flowSlug' is not null or undefined
            assertParamExists('decisionIndexByVersionRunApiV1FlowsFlowSlugDecisionsIndexFlowVersionIdGet', 'flowSlug', flowSlug)
            // verify required parameter 'flowVersionId' is not null or undefined
            assertParamExists('decisionIndexByVersionRunApiV1FlowsFlowSlugDecisionsIndexFlowVersionIdGet', 'flowVersionId', flowVersionId)
            const localVarPath = `/run/api/v1/flows/{flow_slug}/decisions/index/{flow_version_id}`
                .replace(`{${"flow_slug"}}`, encodeURIComponent(String(flowSlug)))
                .replace(`{${"flow_version_id"}}`, encodeURIComponent(String(flowVersionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Download Ml Node Model
         * @param {string} flowSlug 
         * @param {string} modelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadMlNodeModelRunApiV1FlowsFlowSlugMlNodeModelsModelIdModelOnnxGet: async (flowSlug: string, modelId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'flowSlug' is not null or undefined
            assertParamExists('downloadMlNodeModelRunApiV1FlowsFlowSlugMlNodeModelsModelIdModelOnnxGet', 'flowSlug', flowSlug)
            // verify required parameter 'modelId' is not null or undefined
            assertParamExists('downloadMlNodeModelRunApiV1FlowsFlowSlugMlNodeModelsModelIdModelOnnxGet', 'modelId', modelId)
            const localVarPath = `/run/api/v1/flows/{flow_slug}/ml-node/models/{model_id}/model.onnx`
                .replace(`{${"flow_slug"}}`, encodeURIComponent(String(flowSlug)))
                .replace(`{${"model_id"}}`, encodeURIComponent(String(modelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Flow Version
         * @param {string} flowId 
         * @param {string} versionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFlowVersionRunApiV1FlowsFlowIdVersionsVersionIdGet: async (flowId: string, versionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'flowId' is not null or undefined
            assertParamExists('getFlowVersionRunApiV1FlowsFlowIdVersionsVersionIdGet', 'flowId', flowId)
            // verify required parameter 'versionId' is not null or undefined
            assertParamExists('getFlowVersionRunApiV1FlowsFlowIdVersionsVersionIdGet', 'versionId', versionId)
            const localVarPath = `/run/api/v1/flows/{flow_id}/versions/{version_id}`
                .replace(`{${"flow_id"}}`, encodeURIComponent(String(flowId)))
                .replace(`{${"version_id"}}`, encodeURIComponent(String(versionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Flow Versions
         * @param {string} flowSlug 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFlowVersionsRunApiV1FlowsFlowSlugVersionsGet: async (flowSlug: string, skip?: number, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'flowSlug' is not null or undefined
            assertParamExists('getFlowVersionsRunApiV1FlowsFlowSlugVersionsGet', 'flowSlug', flowSlug)
            const localVarPath = `/run/api/v1/flows/{flow_slug}/versions`
                .replace(`{${"flow_slug"}}`, encodeURIComponent(String(flowSlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Production Decide
         * @param {string} flowSlug 
         * @param {string} decisionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductionDecideRunApiV1FlowsFlowSlugDecideDecisionIdGet: async (flowSlug: string, decisionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'flowSlug' is not null or undefined
            assertParamExists('getProductionDecideRunApiV1FlowsFlowSlugDecideDecisionIdGet', 'flowSlug', flowSlug)
            // verify required parameter 'decisionId' is not null or undefined
            assertParamExists('getProductionDecideRunApiV1FlowsFlowSlugDecideDecisionIdGet', 'decisionId', decisionId)
            const localVarPath = `/run/api/v1/flows/{flow_slug}/decide/{decision_id}`
                .replace(`{${"flow_slug"}}`, encodeURIComponent(String(flowSlug)))
                .replace(`{${"decision_id"}}`, encodeURIComponent(String(decisionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Sandbox Decide
         * @param {string} flowSlug 
         * @param {string} decisionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSandboxDecideRunApiV1FlowsFlowSlugSandboxDecideDecisionIdGet: async (flowSlug: string, decisionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'flowSlug' is not null or undefined
            assertParamExists('getSandboxDecideRunApiV1FlowsFlowSlugSandboxDecideDecisionIdGet', 'flowSlug', flowSlug)
            // verify required parameter 'decisionId' is not null or undefined
            assertParamExists('getSandboxDecideRunApiV1FlowsFlowSlugSandboxDecideDecisionIdGet', 'decisionId', decisionId)
            const localVarPath = `/run/api/v1/flows/{flow_slug}/sandbox/decide/{decision_id}`
                .replace(`{${"flow_slug"}}`, encodeURIComponent(String(flowSlug)))
                .replace(`{${"decision_id"}}`, encodeURIComponent(String(decisionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Poll Ml Node Model
         * @param {string} flowSlug 
         * @param {string} modelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pollMlNodeModelRunApiV1FlowsFlowSlugMlNodeModelsModelIdGet: async (flowSlug: string, modelId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'flowSlug' is not null or undefined
            assertParamExists('pollMlNodeModelRunApiV1FlowsFlowSlugMlNodeModelsModelIdGet', 'flowSlug', flowSlug)
            // verify required parameter 'modelId' is not null or undefined
            assertParamExists('pollMlNodeModelRunApiV1FlowsFlowSlugMlNodeModelsModelIdGet', 'modelId', modelId)
            const localVarPath = `/run/api/v1/flows/{flow_slug}/ml-node/models/{model_id}`
                .replace(`{${"flow_slug"}}`, encodeURIComponent(String(flowSlug)))
                .replace(`{${"model_id"}}`, encodeURIComponent(String(modelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Post Reload Flow Cache
         * @param {string} flowSlug 
         * @param {string} flowVersionName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postReloadFlowCacheRunApiV1FlowsFlowSlugReloadFlowVersionNamePost: async (flowSlug: string, flowVersionName: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'flowSlug' is not null or undefined
            assertParamExists('postReloadFlowCacheRunApiV1FlowsFlowSlugReloadFlowVersionNamePost', 'flowSlug', flowSlug)
            // verify required parameter 'flowVersionName' is not null or undefined
            assertParamExists('postReloadFlowCacheRunApiV1FlowsFlowSlugReloadFlowVersionNamePost', 'flowVersionName', flowVersionName)
            const localVarPath = `/run/api/v1/flows/{flow_slug}/reload/{flow_version_name}`
                .replace(`{${"flow_slug"}}`, encodeURIComponent(String(flowSlug)))
                .replace(`{${"flow_version_name"}}`, encodeURIComponent(String(flowVersionName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Put Ml Node Models
         * @param {string} flowSlug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putMlNodeModelsRunApiV1FlowsFlowSlugMlNodeModelsPut: async (flowSlug: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'flowSlug' is not null or undefined
            assertParamExists('putMlNodeModelsRunApiV1FlowsFlowSlugMlNodeModelsPut', 'flowSlug', flowSlug)
            const localVarPath = `/run/api/v1/flows/{flow_slug}/ml-node/models`
                .replace(`{${"flow_slug"}}`, encodeURIComponent(String(flowSlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint simulates a client warmup. This is a no-op and just emits a metric that we can alarm on.
         * @summary Warmup
         * @param {WarmupRequest} warmupRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warmupRunApiV1FlowsWarmupPost: async (warmupRequest: WarmupRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'warmupRequest' is not null or undefined
            assertParamExists('warmupRunApiV1FlowsWarmupPost', 'warmupRequest', warmupRequest)
            const localVarPath = `/run/api/v1/flows/warmup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(warmupRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint simulates a client webhook. This is a no-op and just emits a metric that we can alarm on.
         * @summary Webhook Invoke
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webhookInvokeRunApiV1FlowsWebhookPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/run/api/v1/flows/webhook`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Analyze
         * @param {string} flowSlug 
         * @param {AuthorAnalysisRouterRequest} authorAnalysisRouterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async analyzeRunApiV1FlowsFlowSlugAuthorAnalyzePost(flowSlug: string, authorAnalysisRouterRequest: AuthorAnalysisRouterRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.analyzeRunApiV1FlowsFlowSlugAuthorAnalyzePost(flowSlug, authorAnalysisRouterRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.analyzeRunApiV1FlowsFlowSlugAuthorAnalyzePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Decision By Id
         * @param {string} flowSlug 
         * @param {string} decisionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async decisionByIdRunApiV1FlowsFlowSlugDecisionsDecisionIdGet(flowSlug: string, decisionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DecisionHistoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.decisionByIdRunApiV1FlowsFlowSlugDecisionsDecisionIdGet(flowSlug, decisionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.decisionByIdRunApiV1FlowsFlowSlugDecisionsDecisionIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Decision Index By Version
         * @param {string} flowSlug 
         * @param {string} flowVersionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async decisionIndexByVersionRunApiV1FlowsFlowSlugDecisionsIndexFlowVersionIdGet(flowSlug: string, flowVersionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DecisionHistoryIndexResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.decisionIndexByVersionRunApiV1FlowsFlowSlugDecisionsIndexFlowVersionIdGet(flowSlug, flowVersionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.decisionIndexByVersionRunApiV1FlowsFlowSlugDecisionsIndexFlowVersionIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Download Ml Node Model
         * @param {string} flowSlug 
         * @param {string} modelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadMlNodeModelRunApiV1FlowsFlowSlugMlNodeModelsModelIdModelOnnxGet(flowSlug: string, modelId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadMlNodeModelRunApiV1FlowsFlowSlugMlNodeModelsModelIdModelOnnxGet(flowSlug, modelId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.downloadMlNodeModelRunApiV1FlowsFlowSlugMlNodeModelsModelIdModelOnnxGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Flow Version
         * @param {string} flowId 
         * @param {string} versionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFlowVersionRunApiV1FlowsFlowIdVersionsVersionIdGet(flowId: string, versionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublicFlowVersion>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFlowVersionRunApiV1FlowsFlowIdVersionsVersionIdGet(flowId, versionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getFlowVersionRunApiV1FlowsFlowIdVersionsVersionIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Flow Versions
         * @param {string} flowSlug 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFlowVersionsRunApiV1FlowsFlowSlugVersionsGet(flowSlug: string, skip?: number, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FlowVersionShallow>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFlowVersionsRunApiV1FlowsFlowSlugVersionsGet(flowSlug, skip, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getFlowVersionsRunApiV1FlowsFlowSlugVersionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Production Decide
         * @param {string} flowSlug 
         * @param {string} decisionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductionDecideRunApiV1FlowsFlowSlugDecideDecisionIdGet(flowSlug: string, decisionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DecideResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductionDecideRunApiV1FlowsFlowSlugDecideDecisionIdGet(flowSlug, decisionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getProductionDecideRunApiV1FlowsFlowSlugDecideDecisionIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Sandbox Decide
         * @param {string} flowSlug 
         * @param {string} decisionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSandboxDecideRunApiV1FlowsFlowSlugSandboxDecideDecisionIdGet(flowSlug: string, decisionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DecideResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSandboxDecideRunApiV1FlowsFlowSlugSandboxDecideDecisionIdGet(flowSlug, decisionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getSandboxDecideRunApiV1FlowsFlowSlugSandboxDecideDecisionIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Poll Ml Node Model
         * @param {string} flowSlug 
         * @param {string} modelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pollMlNodeModelRunApiV1FlowsFlowSlugMlNodeModelsModelIdGet(flowSlug: string, modelId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MLNodePollResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pollMlNodeModelRunApiV1FlowsFlowSlugMlNodeModelsModelIdGet(flowSlug, modelId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.pollMlNodeModelRunApiV1FlowsFlowSlugMlNodeModelsModelIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Post Reload Flow Cache
         * @param {string} flowSlug 
         * @param {string} flowVersionName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postReloadFlowCacheRunApiV1FlowsFlowSlugReloadFlowVersionNamePost(flowSlug: string, flowVersionName: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postReloadFlowCacheRunApiV1FlowsFlowSlugReloadFlowVersionNamePost(flowSlug, flowVersionName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.postReloadFlowCacheRunApiV1FlowsFlowSlugReloadFlowVersionNamePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Put Ml Node Models
         * @param {string} flowSlug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putMlNodeModelsRunApiV1FlowsFlowSlugMlNodeModelsPut(flowSlug: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MLNodeUploadResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putMlNodeModelsRunApiV1FlowsFlowSlugMlNodeModelsPut(flowSlug, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.putMlNodeModelsRunApiV1FlowsFlowSlugMlNodeModelsPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * This endpoint simulates a client warmup. This is a no-op and just emits a metric that we can alarm on.
         * @summary Warmup
         * @param {WarmupRequest} warmupRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async warmupRunApiV1FlowsWarmupPost(warmupRequest: WarmupRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.warmupRunApiV1FlowsWarmupPost(warmupRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.warmupRunApiV1FlowsWarmupPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * This endpoint simulates a client webhook. This is a no-op and just emits a metric that we can alarm on.
         * @summary Webhook Invoke
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webhookInvokeRunApiV1FlowsWebhookPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webhookInvokeRunApiV1FlowsWebhookPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.webhookInvokeRunApiV1FlowsWebhookPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultApiFp(configuration)
    return {
        /**
         * 
         * @summary Analyze
         * @param {DefaultApiAnalyzeRunApiV1FlowsFlowSlugAuthorAnalyzePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyzeRunApiV1FlowsFlowSlugAuthorAnalyzePost(requestParameters: DefaultApiAnalyzeRunApiV1FlowsFlowSlugAuthorAnalyzePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.analyzeRunApiV1FlowsFlowSlugAuthorAnalyzePost(requestParameters.flowSlug, requestParameters.authorAnalysisRouterRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Decision By Id
         * @param {DefaultApiDecisionByIdRunApiV1FlowsFlowSlugDecisionsDecisionIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        decisionByIdRunApiV1FlowsFlowSlugDecisionsDecisionIdGet(requestParameters: DefaultApiDecisionByIdRunApiV1FlowsFlowSlugDecisionsDecisionIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DecisionHistoryResponse> {
            return localVarFp.decisionByIdRunApiV1FlowsFlowSlugDecisionsDecisionIdGet(requestParameters.flowSlug, requestParameters.decisionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Decision Index By Version
         * @param {DefaultApiDecisionIndexByVersionRunApiV1FlowsFlowSlugDecisionsIndexFlowVersionIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        decisionIndexByVersionRunApiV1FlowsFlowSlugDecisionsIndexFlowVersionIdGet(requestParameters: DefaultApiDecisionIndexByVersionRunApiV1FlowsFlowSlugDecisionsIndexFlowVersionIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DecisionHistoryIndexResponse> {
            return localVarFp.decisionIndexByVersionRunApiV1FlowsFlowSlugDecisionsIndexFlowVersionIdGet(requestParameters.flowSlug, requestParameters.flowVersionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Download Ml Node Model
         * @param {DefaultApiDownloadMlNodeModelRunApiV1FlowsFlowSlugMlNodeModelsModelIdModelOnnxGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadMlNodeModelRunApiV1FlowsFlowSlugMlNodeModelsModelIdModelOnnxGet(requestParameters: DefaultApiDownloadMlNodeModelRunApiV1FlowsFlowSlugMlNodeModelsModelIdModelOnnxGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.downloadMlNodeModelRunApiV1FlowsFlowSlugMlNodeModelsModelIdModelOnnxGet(requestParameters.flowSlug, requestParameters.modelId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Flow Version
         * @param {DefaultApiGetFlowVersionRunApiV1FlowsFlowIdVersionsVersionIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFlowVersionRunApiV1FlowsFlowIdVersionsVersionIdGet(requestParameters: DefaultApiGetFlowVersionRunApiV1FlowsFlowIdVersionsVersionIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PublicFlowVersion> {
            return localVarFp.getFlowVersionRunApiV1FlowsFlowIdVersionsVersionIdGet(requestParameters.flowId, requestParameters.versionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Flow Versions
         * @param {DefaultApiGetFlowVersionsRunApiV1FlowsFlowSlugVersionsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFlowVersionsRunApiV1FlowsFlowSlugVersionsGet(requestParameters: DefaultApiGetFlowVersionsRunApiV1FlowsFlowSlugVersionsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<FlowVersionShallow>> {
            return localVarFp.getFlowVersionsRunApiV1FlowsFlowSlugVersionsGet(requestParameters.flowSlug, requestParameters.skip, requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Production Decide
         * @param {DefaultApiGetProductionDecideRunApiV1FlowsFlowSlugDecideDecisionIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductionDecideRunApiV1FlowsFlowSlugDecideDecisionIdGet(requestParameters: DefaultApiGetProductionDecideRunApiV1FlowsFlowSlugDecideDecisionIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DecideResponse> {
            return localVarFp.getProductionDecideRunApiV1FlowsFlowSlugDecideDecisionIdGet(requestParameters.flowSlug, requestParameters.decisionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Sandbox Decide
         * @param {DefaultApiGetSandboxDecideRunApiV1FlowsFlowSlugSandboxDecideDecisionIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSandboxDecideRunApiV1FlowsFlowSlugSandboxDecideDecisionIdGet(requestParameters: DefaultApiGetSandboxDecideRunApiV1FlowsFlowSlugSandboxDecideDecisionIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DecideResponse> {
            return localVarFp.getSandboxDecideRunApiV1FlowsFlowSlugSandboxDecideDecisionIdGet(requestParameters.flowSlug, requestParameters.decisionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Poll Ml Node Model
         * @param {DefaultApiPollMlNodeModelRunApiV1FlowsFlowSlugMlNodeModelsModelIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pollMlNodeModelRunApiV1FlowsFlowSlugMlNodeModelsModelIdGet(requestParameters: DefaultApiPollMlNodeModelRunApiV1FlowsFlowSlugMlNodeModelsModelIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<MLNodePollResult> {
            return localVarFp.pollMlNodeModelRunApiV1FlowsFlowSlugMlNodeModelsModelIdGet(requestParameters.flowSlug, requestParameters.modelId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Post Reload Flow Cache
         * @param {DefaultApiPostReloadFlowCacheRunApiV1FlowsFlowSlugReloadFlowVersionNamePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postReloadFlowCacheRunApiV1FlowsFlowSlugReloadFlowVersionNamePost(requestParameters: DefaultApiPostReloadFlowCacheRunApiV1FlowsFlowSlugReloadFlowVersionNamePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.postReloadFlowCacheRunApiV1FlowsFlowSlugReloadFlowVersionNamePost(requestParameters.flowSlug, requestParameters.flowVersionName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Put Ml Node Models
         * @param {DefaultApiPutMlNodeModelsRunApiV1FlowsFlowSlugMlNodeModelsPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putMlNodeModelsRunApiV1FlowsFlowSlugMlNodeModelsPut(requestParameters: DefaultApiPutMlNodeModelsRunApiV1FlowsFlowSlugMlNodeModelsPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<MLNodeUploadResponse> {
            return localVarFp.putMlNodeModelsRunApiV1FlowsFlowSlugMlNodeModelsPut(requestParameters.flowSlug, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint simulates a client warmup. This is a no-op and just emits a metric that we can alarm on.
         * @summary Warmup
         * @param {DefaultApiWarmupRunApiV1FlowsWarmupPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warmupRunApiV1FlowsWarmupPost(requestParameters: DefaultApiWarmupRunApiV1FlowsWarmupPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.warmupRunApiV1FlowsWarmupPost(requestParameters.warmupRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint simulates a client webhook. This is a no-op and just emits a metric that we can alarm on.
         * @summary Webhook Invoke
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webhookInvokeRunApiV1FlowsWebhookPost(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.webhookInvokeRunApiV1FlowsWebhookPost(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for analyzeRunApiV1FlowsFlowSlugAuthorAnalyzePost operation in DefaultApi.
 * @export
 * @interface DefaultApiAnalyzeRunApiV1FlowsFlowSlugAuthorAnalyzePostRequest
 */
export interface DefaultApiAnalyzeRunApiV1FlowsFlowSlugAuthorAnalyzePostRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiAnalyzeRunApiV1FlowsFlowSlugAuthorAnalyzePost
     */
    readonly flowSlug: string

    /**
     * 
     * @type {AuthorAnalysisRouterRequest}
     * @memberof DefaultApiAnalyzeRunApiV1FlowsFlowSlugAuthorAnalyzePost
     */
    readonly authorAnalysisRouterRequest: AuthorAnalysisRouterRequest
}

/**
 * Request parameters for decisionByIdRunApiV1FlowsFlowSlugDecisionsDecisionIdGet operation in DefaultApi.
 * @export
 * @interface DefaultApiDecisionByIdRunApiV1FlowsFlowSlugDecisionsDecisionIdGetRequest
 */
export interface DefaultApiDecisionByIdRunApiV1FlowsFlowSlugDecisionsDecisionIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiDecisionByIdRunApiV1FlowsFlowSlugDecisionsDecisionIdGet
     */
    readonly flowSlug: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiDecisionByIdRunApiV1FlowsFlowSlugDecisionsDecisionIdGet
     */
    readonly decisionId: string
}

/**
 * Request parameters for decisionIndexByVersionRunApiV1FlowsFlowSlugDecisionsIndexFlowVersionIdGet operation in DefaultApi.
 * @export
 * @interface DefaultApiDecisionIndexByVersionRunApiV1FlowsFlowSlugDecisionsIndexFlowVersionIdGetRequest
 */
export interface DefaultApiDecisionIndexByVersionRunApiV1FlowsFlowSlugDecisionsIndexFlowVersionIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiDecisionIndexByVersionRunApiV1FlowsFlowSlugDecisionsIndexFlowVersionIdGet
     */
    readonly flowSlug: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiDecisionIndexByVersionRunApiV1FlowsFlowSlugDecisionsIndexFlowVersionIdGet
     */
    readonly flowVersionId: string
}

/**
 * Request parameters for downloadMlNodeModelRunApiV1FlowsFlowSlugMlNodeModelsModelIdModelOnnxGet operation in DefaultApi.
 * @export
 * @interface DefaultApiDownloadMlNodeModelRunApiV1FlowsFlowSlugMlNodeModelsModelIdModelOnnxGetRequest
 */
export interface DefaultApiDownloadMlNodeModelRunApiV1FlowsFlowSlugMlNodeModelsModelIdModelOnnxGetRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiDownloadMlNodeModelRunApiV1FlowsFlowSlugMlNodeModelsModelIdModelOnnxGet
     */
    readonly flowSlug: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiDownloadMlNodeModelRunApiV1FlowsFlowSlugMlNodeModelsModelIdModelOnnxGet
     */
    readonly modelId: string
}

/**
 * Request parameters for getFlowVersionRunApiV1FlowsFlowIdVersionsVersionIdGet operation in DefaultApi.
 * @export
 * @interface DefaultApiGetFlowVersionRunApiV1FlowsFlowIdVersionsVersionIdGetRequest
 */
export interface DefaultApiGetFlowVersionRunApiV1FlowsFlowIdVersionsVersionIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetFlowVersionRunApiV1FlowsFlowIdVersionsVersionIdGet
     */
    readonly flowId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetFlowVersionRunApiV1FlowsFlowIdVersionsVersionIdGet
     */
    readonly versionId: string
}

/**
 * Request parameters for getFlowVersionsRunApiV1FlowsFlowSlugVersionsGet operation in DefaultApi.
 * @export
 * @interface DefaultApiGetFlowVersionsRunApiV1FlowsFlowSlugVersionsGetRequest
 */
export interface DefaultApiGetFlowVersionsRunApiV1FlowsFlowSlugVersionsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetFlowVersionsRunApiV1FlowsFlowSlugVersionsGet
     */
    readonly flowSlug: string

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetFlowVersionsRunApiV1FlowsFlowSlugVersionsGet
     */
    readonly skip?: number

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetFlowVersionsRunApiV1FlowsFlowSlugVersionsGet
     */
    readonly limit?: number
}

/**
 * Request parameters for getProductionDecideRunApiV1FlowsFlowSlugDecideDecisionIdGet operation in DefaultApi.
 * @export
 * @interface DefaultApiGetProductionDecideRunApiV1FlowsFlowSlugDecideDecisionIdGetRequest
 */
export interface DefaultApiGetProductionDecideRunApiV1FlowsFlowSlugDecideDecisionIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetProductionDecideRunApiV1FlowsFlowSlugDecideDecisionIdGet
     */
    readonly flowSlug: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetProductionDecideRunApiV1FlowsFlowSlugDecideDecisionIdGet
     */
    readonly decisionId: string
}

/**
 * Request parameters for getSandboxDecideRunApiV1FlowsFlowSlugSandboxDecideDecisionIdGet operation in DefaultApi.
 * @export
 * @interface DefaultApiGetSandboxDecideRunApiV1FlowsFlowSlugSandboxDecideDecisionIdGetRequest
 */
export interface DefaultApiGetSandboxDecideRunApiV1FlowsFlowSlugSandboxDecideDecisionIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetSandboxDecideRunApiV1FlowsFlowSlugSandboxDecideDecisionIdGet
     */
    readonly flowSlug: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetSandboxDecideRunApiV1FlowsFlowSlugSandboxDecideDecisionIdGet
     */
    readonly decisionId: string
}

/**
 * Request parameters for pollMlNodeModelRunApiV1FlowsFlowSlugMlNodeModelsModelIdGet operation in DefaultApi.
 * @export
 * @interface DefaultApiPollMlNodeModelRunApiV1FlowsFlowSlugMlNodeModelsModelIdGetRequest
 */
export interface DefaultApiPollMlNodeModelRunApiV1FlowsFlowSlugMlNodeModelsModelIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiPollMlNodeModelRunApiV1FlowsFlowSlugMlNodeModelsModelIdGet
     */
    readonly flowSlug: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiPollMlNodeModelRunApiV1FlowsFlowSlugMlNodeModelsModelIdGet
     */
    readonly modelId: string
}

/**
 * Request parameters for postReloadFlowCacheRunApiV1FlowsFlowSlugReloadFlowVersionNamePost operation in DefaultApi.
 * @export
 * @interface DefaultApiPostReloadFlowCacheRunApiV1FlowsFlowSlugReloadFlowVersionNamePostRequest
 */
export interface DefaultApiPostReloadFlowCacheRunApiV1FlowsFlowSlugReloadFlowVersionNamePostRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiPostReloadFlowCacheRunApiV1FlowsFlowSlugReloadFlowVersionNamePost
     */
    readonly flowSlug: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiPostReloadFlowCacheRunApiV1FlowsFlowSlugReloadFlowVersionNamePost
     */
    readonly flowVersionName: string
}

/**
 * Request parameters for putMlNodeModelsRunApiV1FlowsFlowSlugMlNodeModelsPut operation in DefaultApi.
 * @export
 * @interface DefaultApiPutMlNodeModelsRunApiV1FlowsFlowSlugMlNodeModelsPutRequest
 */
export interface DefaultApiPutMlNodeModelsRunApiV1FlowsFlowSlugMlNodeModelsPutRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiPutMlNodeModelsRunApiV1FlowsFlowSlugMlNodeModelsPut
     */
    readonly flowSlug: string
}

/**
 * Request parameters for warmupRunApiV1FlowsWarmupPost operation in DefaultApi.
 * @export
 * @interface DefaultApiWarmupRunApiV1FlowsWarmupPostRequest
 */
export interface DefaultApiWarmupRunApiV1FlowsWarmupPostRequest {
    /**
     * 
     * @type {WarmupRequest}
     * @memberof DefaultApiWarmupRunApiV1FlowsWarmupPost
     */
    readonly warmupRequest: WarmupRequest
}

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     * 
     * @summary Analyze
     * @param {DefaultApiAnalyzeRunApiV1FlowsFlowSlugAuthorAnalyzePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public analyzeRunApiV1FlowsFlowSlugAuthorAnalyzePost(requestParameters: DefaultApiAnalyzeRunApiV1FlowsFlowSlugAuthorAnalyzePostRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).analyzeRunApiV1FlowsFlowSlugAuthorAnalyzePost(requestParameters.flowSlug, requestParameters.authorAnalysisRouterRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Decision By Id
     * @param {DefaultApiDecisionByIdRunApiV1FlowsFlowSlugDecisionsDecisionIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public decisionByIdRunApiV1FlowsFlowSlugDecisionsDecisionIdGet(requestParameters: DefaultApiDecisionByIdRunApiV1FlowsFlowSlugDecisionsDecisionIdGetRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).decisionByIdRunApiV1FlowsFlowSlugDecisionsDecisionIdGet(requestParameters.flowSlug, requestParameters.decisionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Decision Index By Version
     * @param {DefaultApiDecisionIndexByVersionRunApiV1FlowsFlowSlugDecisionsIndexFlowVersionIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public decisionIndexByVersionRunApiV1FlowsFlowSlugDecisionsIndexFlowVersionIdGet(requestParameters: DefaultApiDecisionIndexByVersionRunApiV1FlowsFlowSlugDecisionsIndexFlowVersionIdGetRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).decisionIndexByVersionRunApiV1FlowsFlowSlugDecisionsIndexFlowVersionIdGet(requestParameters.flowSlug, requestParameters.flowVersionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Download Ml Node Model
     * @param {DefaultApiDownloadMlNodeModelRunApiV1FlowsFlowSlugMlNodeModelsModelIdModelOnnxGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public downloadMlNodeModelRunApiV1FlowsFlowSlugMlNodeModelsModelIdModelOnnxGet(requestParameters: DefaultApiDownloadMlNodeModelRunApiV1FlowsFlowSlugMlNodeModelsModelIdModelOnnxGetRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).downloadMlNodeModelRunApiV1FlowsFlowSlugMlNodeModelsModelIdModelOnnxGet(requestParameters.flowSlug, requestParameters.modelId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Flow Version
     * @param {DefaultApiGetFlowVersionRunApiV1FlowsFlowIdVersionsVersionIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getFlowVersionRunApiV1FlowsFlowIdVersionsVersionIdGet(requestParameters: DefaultApiGetFlowVersionRunApiV1FlowsFlowIdVersionsVersionIdGetRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getFlowVersionRunApiV1FlowsFlowIdVersionsVersionIdGet(requestParameters.flowId, requestParameters.versionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Flow Versions
     * @param {DefaultApiGetFlowVersionsRunApiV1FlowsFlowSlugVersionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getFlowVersionsRunApiV1FlowsFlowSlugVersionsGet(requestParameters: DefaultApiGetFlowVersionsRunApiV1FlowsFlowSlugVersionsGetRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getFlowVersionsRunApiV1FlowsFlowSlugVersionsGet(requestParameters.flowSlug, requestParameters.skip, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Production Decide
     * @param {DefaultApiGetProductionDecideRunApiV1FlowsFlowSlugDecideDecisionIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getProductionDecideRunApiV1FlowsFlowSlugDecideDecisionIdGet(requestParameters: DefaultApiGetProductionDecideRunApiV1FlowsFlowSlugDecideDecisionIdGetRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getProductionDecideRunApiV1FlowsFlowSlugDecideDecisionIdGet(requestParameters.flowSlug, requestParameters.decisionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Sandbox Decide
     * @param {DefaultApiGetSandboxDecideRunApiV1FlowsFlowSlugSandboxDecideDecisionIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getSandboxDecideRunApiV1FlowsFlowSlugSandboxDecideDecisionIdGet(requestParameters: DefaultApiGetSandboxDecideRunApiV1FlowsFlowSlugSandboxDecideDecisionIdGetRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getSandboxDecideRunApiV1FlowsFlowSlugSandboxDecideDecisionIdGet(requestParameters.flowSlug, requestParameters.decisionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Poll Ml Node Model
     * @param {DefaultApiPollMlNodeModelRunApiV1FlowsFlowSlugMlNodeModelsModelIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public pollMlNodeModelRunApiV1FlowsFlowSlugMlNodeModelsModelIdGet(requestParameters: DefaultApiPollMlNodeModelRunApiV1FlowsFlowSlugMlNodeModelsModelIdGetRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).pollMlNodeModelRunApiV1FlowsFlowSlugMlNodeModelsModelIdGet(requestParameters.flowSlug, requestParameters.modelId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Post Reload Flow Cache
     * @param {DefaultApiPostReloadFlowCacheRunApiV1FlowsFlowSlugReloadFlowVersionNamePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public postReloadFlowCacheRunApiV1FlowsFlowSlugReloadFlowVersionNamePost(requestParameters: DefaultApiPostReloadFlowCacheRunApiV1FlowsFlowSlugReloadFlowVersionNamePostRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).postReloadFlowCacheRunApiV1FlowsFlowSlugReloadFlowVersionNamePost(requestParameters.flowSlug, requestParameters.flowVersionName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Put Ml Node Models
     * @param {DefaultApiPutMlNodeModelsRunApiV1FlowsFlowSlugMlNodeModelsPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public putMlNodeModelsRunApiV1FlowsFlowSlugMlNodeModelsPut(requestParameters: DefaultApiPutMlNodeModelsRunApiV1FlowsFlowSlugMlNodeModelsPutRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).putMlNodeModelsRunApiV1FlowsFlowSlugMlNodeModelsPut(requestParameters.flowSlug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint simulates a client warmup. This is a no-op and just emits a metric that we can alarm on.
     * @summary Warmup
     * @param {DefaultApiWarmupRunApiV1FlowsWarmupPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public warmupRunApiV1FlowsWarmupPost(requestParameters: DefaultApiWarmupRunApiV1FlowsWarmupPostRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).warmupRunApiV1FlowsWarmupPost(requestParameters.warmupRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint simulates a client webhook. This is a no-op and just emits a metric that we can alarm on.
     * @summary Webhook Invoke
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public webhookInvokeRunApiV1FlowsWebhookPost(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).webhookInvokeRunApiV1FlowsWebhookPost(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * InfoApi - axios parameter creator
 * @export
 */
export const InfoApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Flow Info
         * @param {boolean} [includeCfnLastUpdated] 
         * @param {boolean} [includeLogInsightsLink] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        flowInfoRunApiV1InfoGet: async (includeCfnLastUpdated?: boolean, includeLogInsightsLink?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/run/api/v1/_info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (includeCfnLastUpdated !== undefined) {
                localVarQueryParameter['include_cfn_last_updated'] = includeCfnLastUpdated;
            }

            if (includeLogInsightsLink !== undefined) {
                localVarQueryParameter['include_log_insights_link'] = includeLogInsightsLink;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InfoApi - functional programming interface
 * @export
 */
export const InfoApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InfoApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Flow Info
         * @param {boolean} [includeCfnLastUpdated] 
         * @param {boolean} [includeLogInsightsLink] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async flowInfoRunApiV1InfoGet(includeCfnLastUpdated?: boolean, includeLogInsightsLink?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServiceInfraMetadata>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.flowInfoRunApiV1InfoGet(includeCfnLastUpdated, includeLogInsightsLink, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InfoApi.flowInfoRunApiV1InfoGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InfoApi - factory interface
 * @export
 */
export const InfoApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InfoApiFp(configuration)
    return {
        /**
         * 
         * @summary Flow Info
         * @param {InfoApiFlowInfoRunApiV1InfoGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        flowInfoRunApiV1InfoGet(requestParameters: InfoApiFlowInfoRunApiV1InfoGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ServiceInfraMetadata> {
            return localVarFp.flowInfoRunApiV1InfoGet(requestParameters.includeCfnLastUpdated, requestParameters.includeLogInsightsLink, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for flowInfoRunApiV1InfoGet operation in InfoApi.
 * @export
 * @interface InfoApiFlowInfoRunApiV1InfoGetRequest
 */
export interface InfoApiFlowInfoRunApiV1InfoGetRequest {
    /**
     * 
     * @type {boolean}
     * @memberof InfoApiFlowInfoRunApiV1InfoGet
     */
    readonly includeCfnLastUpdated?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof InfoApiFlowInfoRunApiV1InfoGet
     */
    readonly includeLogInsightsLink?: boolean
}

/**
 * InfoApi - object-oriented interface
 * @export
 * @class InfoApi
 * @extends {BaseAPI}
 */
export class InfoApi extends BaseAPI {
    /**
     * 
     * @summary Flow Info
     * @param {InfoApiFlowInfoRunApiV1InfoGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InfoApi
     */
    public flowInfoRunApiV1InfoGet(requestParameters: InfoApiFlowInfoRunApiV1InfoGetRequest = {}, options?: RawAxiosRequestConfig) {
        return InfoApiFp(this.configuration).flowInfoRunApiV1InfoGet(requestParameters.includeCfnLastUpdated, requestParameters.includeLogInsightsLink, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * JobRunsApi - axios parameter creator
 * @export
 */
export const JobRunsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Submit Job Run
         * @param {JobRunRequestPostData} jobRunRequestPostData 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitJobRunRunApiV1JobRunsPost: async (jobRunRequestPostData: JobRunRequestPostData, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobRunRequestPostData' is not null or undefined
            assertParamExists('submitJobRunRunApiV1JobRunsPost', 'jobRunRequestPostData', jobRunRequestPostData)
            const localVarPath = `/run/api/v1/job-runs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(jobRunRequestPostData, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * JobRunsApi - functional programming interface
 * @export
 */
export const JobRunsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = JobRunsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Submit Job Run
         * @param {JobRunRequestPostData} jobRunRequestPostData 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submitJobRunRunApiV1JobRunsPost(jobRunRequestPostData: JobRunRequestPostData, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submitJobRunRunApiV1JobRunsPost(jobRunRequestPostData, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobRunsApi.submitJobRunRunApiV1JobRunsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * JobRunsApi - factory interface
 * @export
 */
export const JobRunsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = JobRunsApiFp(configuration)
    return {
        /**
         * 
         * @summary Submit Job Run
         * @param {JobRunsApiSubmitJobRunRunApiV1JobRunsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitJobRunRunApiV1JobRunsPost(requestParameters: JobRunsApiSubmitJobRunRunApiV1JobRunsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.submitJobRunRunApiV1JobRunsPost(requestParameters.jobRunRequestPostData, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for submitJobRunRunApiV1JobRunsPost operation in JobRunsApi.
 * @export
 * @interface JobRunsApiSubmitJobRunRunApiV1JobRunsPostRequest
 */
export interface JobRunsApiSubmitJobRunRunApiV1JobRunsPostRequest {
    /**
     * 
     * @type {JobRunRequestPostData}
     * @memberof JobRunsApiSubmitJobRunRunApiV1JobRunsPost
     */
    readonly jobRunRequestPostData: JobRunRequestPostData
}

/**
 * JobRunsApi - object-oriented interface
 * @export
 * @class JobRunsApi
 * @extends {BaseAPI}
 */
export class JobRunsApi extends BaseAPI {
    /**
     * 
     * @summary Submit Job Run
     * @param {JobRunsApiSubmitJobRunRunApiV1JobRunsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobRunsApi
     */
    public submitJobRunRunApiV1JobRunsPost(requestParameters: JobRunsApiSubmitJobRunRunApiV1JobRunsPostRequest, options?: RawAxiosRequestConfig) {
        return JobRunsApiFp(this.configuration).submitJobRunRunApiV1JobRunsPost(requestParameters.jobRunRequestPostData, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TestRunsApi - axios parameter creator
 * @export
 */
export const TestRunsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create Presigned Url
         * @param {string} testRunId 
         * @param {Data} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPresignedUrlRunApiV1TestRunsTestRunIdPresignedUrlsPost: async (testRunId: string, data: Data, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'testRunId' is not null or undefined
            assertParamExists('createPresignedUrlRunApiV1TestRunsTestRunIdPresignedUrlsPost', 'testRunId', testRunId)
            // verify required parameter 'data' is not null or undefined
            assertParamExists('createPresignedUrlRunApiV1TestRunsTestRunIdPresignedUrlsPost', 'data', data)
            const localVarPath = `/run/api/v1/test-runs/{test_run_id}/presigned_urls`
                .replace(`{${"test_run_id"}}`, encodeURIComponent(String(testRunId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(data, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Test Run
         * @param {TestRunCreate} testRunCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTestRunRunApiV1TestRunsPost: async (testRunCreate: TestRunCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'testRunCreate' is not null or undefined
            assertParamExists('createTestRunRunApiV1TestRunsPost', 'testRunCreate', testRunCreate)
            const localVarPath = `/run/api/v1/test-runs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(testRunCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Invoked by Stitcher asynchronously to populate node analytics.
         * @summary Get Node Analytics For All Nodes
         * @param {string} flowVersionId 
         * @param {string} testRunId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNodeAnalyticsForAllNodesRunApiV1TestRunsTestRunIdVersionsFlowVersionIdAnalyticsGet: async (flowVersionId: string, testRunId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'flowVersionId' is not null or undefined
            assertParamExists('getNodeAnalyticsForAllNodesRunApiV1TestRunsTestRunIdVersionsFlowVersionIdAnalyticsGet', 'flowVersionId', flowVersionId)
            // verify required parameter 'testRunId' is not null or undefined
            assertParamExists('getNodeAnalyticsForAllNodesRunApiV1TestRunsTestRunIdVersionsFlowVersionIdAnalyticsGet', 'testRunId', testRunId)
            const localVarPath = `/run/api/v1/test-runs/{test_run_id}/versions/{flow_version_id}/analytics`
                .replace(`{${"flow_version_id"}}`, encodeURIComponent(String(flowVersionId)))
                .replace(`{${"test_run_id"}}`, encodeURIComponent(String(testRunId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * DEPRECATED: FE uses /presigned_urls instead
         * @summary Get Node Analytics
         * @param {string} flowVersionId 
         * @param {string} testRunId 
         * @param {string} nodeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNodeAnalyticsRunApiV1TestRunsTestRunIdVersionsFlowVersionIdNodesNodeIdAnalyticsGet: async (flowVersionId: string, testRunId: string, nodeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'flowVersionId' is not null or undefined
            assertParamExists('getNodeAnalyticsRunApiV1TestRunsTestRunIdVersionsFlowVersionIdNodesNodeIdAnalyticsGet', 'flowVersionId', flowVersionId)
            // verify required parameter 'testRunId' is not null or undefined
            assertParamExists('getNodeAnalyticsRunApiV1TestRunsTestRunIdVersionsFlowVersionIdNodesNodeIdAnalyticsGet', 'testRunId', testRunId)
            // verify required parameter 'nodeId' is not null or undefined
            assertParamExists('getNodeAnalyticsRunApiV1TestRunsTestRunIdVersionsFlowVersionIdNodesNodeIdAnalyticsGet', 'nodeId', nodeId)
            const localVarPath = `/run/api/v1/test-runs/{test_run_id}/versions/{flow_version_id}/nodes/{node_id}/analytics`
                .replace(`{${"flow_version_id"}}`, encodeURIComponent(String(flowVersionId)))
                .replace(`{${"test_run_id"}}`, encodeURIComponent(String(testRunId)))
                .replace(`{${"node_id"}}`, encodeURIComponent(String(nodeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Test Run
         * @param {string} testRunId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTestRunRunApiV1TestRunsTestRunIdGet: async (testRunId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'testRunId' is not null or undefined
            assertParamExists('getTestRunRunApiV1TestRunsTestRunIdGet', 'testRunId', testRunId)
            const localVarPath = `/run/api/v1/test-runs/{test_run_id}`
                .replace(`{${"test_run_id"}}`, encodeURIComponent(String(testRunId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TestRunsApi - functional programming interface
 * @export
 */
export const TestRunsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TestRunsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create Presigned Url
         * @param {string} testRunId 
         * @param {Data} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPresignedUrlRunApiV1TestRunsTestRunIdPresignedUrlsPost(testRunId: string, data: Data, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PreSignedUrlResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPresignedUrlRunApiV1TestRunsTestRunIdPresignedUrlsPost(testRunId, data, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestRunsApi.createPresignedUrlRunApiV1TestRunsTestRunIdPresignedUrlsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create Test Run
         * @param {TestRunCreate} testRunCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTestRunRunApiV1TestRunsPost(testRunCreate: TestRunCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TestRunResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTestRunRunApiV1TestRunsPost(testRunCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestRunsApi.createTestRunRunApiV1TestRunsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Invoked by Stitcher asynchronously to populate node analytics.
         * @summary Get Node Analytics For All Nodes
         * @param {string} flowVersionId 
         * @param {string} testRunId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNodeAnalyticsForAllNodesRunApiV1TestRunsTestRunIdVersionsFlowVersionIdAnalyticsGet(flowVersionId: string, testRunId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNodeAnalyticsForAllNodesRunApiV1TestRunsTestRunIdVersionsFlowVersionIdAnalyticsGet(flowVersionId, testRunId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestRunsApi.getNodeAnalyticsForAllNodesRunApiV1TestRunsTestRunIdVersionsFlowVersionIdAnalyticsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * DEPRECATED: FE uses /presigned_urls instead
         * @summary Get Node Analytics
         * @param {string} flowVersionId 
         * @param {string} testRunId 
         * @param {string} nodeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNodeAnalyticsRunApiV1TestRunsTestRunIdVersionsFlowVersionIdNodesNodeIdAnalyticsGet(flowVersionId: string, testRunId: string, nodeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PreSignedUrlResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNodeAnalyticsRunApiV1TestRunsTestRunIdVersionsFlowVersionIdNodesNodeIdAnalyticsGet(flowVersionId, testRunId, nodeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestRunsApi.getNodeAnalyticsRunApiV1TestRunsTestRunIdVersionsFlowVersionIdNodesNodeIdAnalyticsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Test Run
         * @param {string} testRunId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTestRunRunApiV1TestRunsTestRunIdGet(testRunId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TestRunResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTestRunRunApiV1TestRunsTestRunIdGet(testRunId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestRunsApi.getTestRunRunApiV1TestRunsTestRunIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TestRunsApi - factory interface
 * @export
 */
export const TestRunsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TestRunsApiFp(configuration)
    return {
        /**
         * 
         * @summary Create Presigned Url
         * @param {TestRunsApiCreatePresignedUrlRunApiV1TestRunsTestRunIdPresignedUrlsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPresignedUrlRunApiV1TestRunsTestRunIdPresignedUrlsPost(requestParameters: TestRunsApiCreatePresignedUrlRunApiV1TestRunsTestRunIdPresignedUrlsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PreSignedUrlResponse> {
            return localVarFp.createPresignedUrlRunApiV1TestRunsTestRunIdPresignedUrlsPost(requestParameters.testRunId, requestParameters.data, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Test Run
         * @param {TestRunsApiCreateTestRunRunApiV1TestRunsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTestRunRunApiV1TestRunsPost(requestParameters: TestRunsApiCreateTestRunRunApiV1TestRunsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TestRunResponse> {
            return localVarFp.createTestRunRunApiV1TestRunsPost(requestParameters.testRunCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * Invoked by Stitcher asynchronously to populate node analytics.
         * @summary Get Node Analytics For All Nodes
         * @param {TestRunsApiGetNodeAnalyticsForAllNodesRunApiV1TestRunsTestRunIdVersionsFlowVersionIdAnalyticsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNodeAnalyticsForAllNodesRunApiV1TestRunsTestRunIdVersionsFlowVersionIdAnalyticsGet(requestParameters: TestRunsApiGetNodeAnalyticsForAllNodesRunApiV1TestRunsTestRunIdVersionsFlowVersionIdAnalyticsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getNodeAnalyticsForAllNodesRunApiV1TestRunsTestRunIdVersionsFlowVersionIdAnalyticsGet(requestParameters.flowVersionId, requestParameters.testRunId, options).then((request) => request(axios, basePath));
        },
        /**
         * DEPRECATED: FE uses /presigned_urls instead
         * @summary Get Node Analytics
         * @param {TestRunsApiGetNodeAnalyticsRunApiV1TestRunsTestRunIdVersionsFlowVersionIdNodesNodeIdAnalyticsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNodeAnalyticsRunApiV1TestRunsTestRunIdVersionsFlowVersionIdNodesNodeIdAnalyticsGet(requestParameters: TestRunsApiGetNodeAnalyticsRunApiV1TestRunsTestRunIdVersionsFlowVersionIdNodesNodeIdAnalyticsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PreSignedUrlResponse> {
            return localVarFp.getNodeAnalyticsRunApiV1TestRunsTestRunIdVersionsFlowVersionIdNodesNodeIdAnalyticsGet(requestParameters.flowVersionId, requestParameters.testRunId, requestParameters.nodeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Test Run
         * @param {TestRunsApiGetTestRunRunApiV1TestRunsTestRunIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTestRunRunApiV1TestRunsTestRunIdGet(requestParameters: TestRunsApiGetTestRunRunApiV1TestRunsTestRunIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<TestRunResponse> {
            return localVarFp.getTestRunRunApiV1TestRunsTestRunIdGet(requestParameters.testRunId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createPresignedUrlRunApiV1TestRunsTestRunIdPresignedUrlsPost operation in TestRunsApi.
 * @export
 * @interface TestRunsApiCreatePresignedUrlRunApiV1TestRunsTestRunIdPresignedUrlsPostRequest
 */
export interface TestRunsApiCreatePresignedUrlRunApiV1TestRunsTestRunIdPresignedUrlsPostRequest {
    /**
     * 
     * @type {string}
     * @memberof TestRunsApiCreatePresignedUrlRunApiV1TestRunsTestRunIdPresignedUrlsPost
     */
    readonly testRunId: string

    /**
     * 
     * @type {Data}
     * @memberof TestRunsApiCreatePresignedUrlRunApiV1TestRunsTestRunIdPresignedUrlsPost
     */
    readonly data: Data
}

/**
 * Request parameters for createTestRunRunApiV1TestRunsPost operation in TestRunsApi.
 * @export
 * @interface TestRunsApiCreateTestRunRunApiV1TestRunsPostRequest
 */
export interface TestRunsApiCreateTestRunRunApiV1TestRunsPostRequest {
    /**
     * 
     * @type {TestRunCreate}
     * @memberof TestRunsApiCreateTestRunRunApiV1TestRunsPost
     */
    readonly testRunCreate: TestRunCreate
}

/**
 * Request parameters for getNodeAnalyticsForAllNodesRunApiV1TestRunsTestRunIdVersionsFlowVersionIdAnalyticsGet operation in TestRunsApi.
 * @export
 * @interface TestRunsApiGetNodeAnalyticsForAllNodesRunApiV1TestRunsTestRunIdVersionsFlowVersionIdAnalyticsGetRequest
 */
export interface TestRunsApiGetNodeAnalyticsForAllNodesRunApiV1TestRunsTestRunIdVersionsFlowVersionIdAnalyticsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof TestRunsApiGetNodeAnalyticsForAllNodesRunApiV1TestRunsTestRunIdVersionsFlowVersionIdAnalyticsGet
     */
    readonly flowVersionId: string

    /**
     * 
     * @type {string}
     * @memberof TestRunsApiGetNodeAnalyticsForAllNodesRunApiV1TestRunsTestRunIdVersionsFlowVersionIdAnalyticsGet
     */
    readonly testRunId: string
}

/**
 * Request parameters for getNodeAnalyticsRunApiV1TestRunsTestRunIdVersionsFlowVersionIdNodesNodeIdAnalyticsGet operation in TestRunsApi.
 * @export
 * @interface TestRunsApiGetNodeAnalyticsRunApiV1TestRunsTestRunIdVersionsFlowVersionIdNodesNodeIdAnalyticsGetRequest
 */
export interface TestRunsApiGetNodeAnalyticsRunApiV1TestRunsTestRunIdVersionsFlowVersionIdNodesNodeIdAnalyticsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof TestRunsApiGetNodeAnalyticsRunApiV1TestRunsTestRunIdVersionsFlowVersionIdNodesNodeIdAnalyticsGet
     */
    readonly flowVersionId: string

    /**
     * 
     * @type {string}
     * @memberof TestRunsApiGetNodeAnalyticsRunApiV1TestRunsTestRunIdVersionsFlowVersionIdNodesNodeIdAnalyticsGet
     */
    readonly testRunId: string

    /**
     * 
     * @type {string}
     * @memberof TestRunsApiGetNodeAnalyticsRunApiV1TestRunsTestRunIdVersionsFlowVersionIdNodesNodeIdAnalyticsGet
     */
    readonly nodeId: string
}

/**
 * Request parameters for getTestRunRunApiV1TestRunsTestRunIdGet operation in TestRunsApi.
 * @export
 * @interface TestRunsApiGetTestRunRunApiV1TestRunsTestRunIdGetRequest
 */
export interface TestRunsApiGetTestRunRunApiV1TestRunsTestRunIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof TestRunsApiGetTestRunRunApiV1TestRunsTestRunIdGet
     */
    readonly testRunId: string
}

/**
 * TestRunsApi - object-oriented interface
 * @export
 * @class TestRunsApi
 * @extends {BaseAPI}
 */
export class TestRunsApi extends BaseAPI {
    /**
     * 
     * @summary Create Presigned Url
     * @param {TestRunsApiCreatePresignedUrlRunApiV1TestRunsTestRunIdPresignedUrlsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestRunsApi
     */
    public createPresignedUrlRunApiV1TestRunsTestRunIdPresignedUrlsPost(requestParameters: TestRunsApiCreatePresignedUrlRunApiV1TestRunsTestRunIdPresignedUrlsPostRequest, options?: RawAxiosRequestConfig) {
        return TestRunsApiFp(this.configuration).createPresignedUrlRunApiV1TestRunsTestRunIdPresignedUrlsPost(requestParameters.testRunId, requestParameters.data, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Test Run
     * @param {TestRunsApiCreateTestRunRunApiV1TestRunsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestRunsApi
     */
    public createTestRunRunApiV1TestRunsPost(requestParameters: TestRunsApiCreateTestRunRunApiV1TestRunsPostRequest, options?: RawAxiosRequestConfig) {
        return TestRunsApiFp(this.configuration).createTestRunRunApiV1TestRunsPost(requestParameters.testRunCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Invoked by Stitcher asynchronously to populate node analytics.
     * @summary Get Node Analytics For All Nodes
     * @param {TestRunsApiGetNodeAnalyticsForAllNodesRunApiV1TestRunsTestRunIdVersionsFlowVersionIdAnalyticsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestRunsApi
     */
    public getNodeAnalyticsForAllNodesRunApiV1TestRunsTestRunIdVersionsFlowVersionIdAnalyticsGet(requestParameters: TestRunsApiGetNodeAnalyticsForAllNodesRunApiV1TestRunsTestRunIdVersionsFlowVersionIdAnalyticsGetRequest, options?: RawAxiosRequestConfig) {
        return TestRunsApiFp(this.configuration).getNodeAnalyticsForAllNodesRunApiV1TestRunsTestRunIdVersionsFlowVersionIdAnalyticsGet(requestParameters.flowVersionId, requestParameters.testRunId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * DEPRECATED: FE uses /presigned_urls instead
     * @summary Get Node Analytics
     * @param {TestRunsApiGetNodeAnalyticsRunApiV1TestRunsTestRunIdVersionsFlowVersionIdNodesNodeIdAnalyticsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestRunsApi
     */
    public getNodeAnalyticsRunApiV1TestRunsTestRunIdVersionsFlowVersionIdNodesNodeIdAnalyticsGet(requestParameters: TestRunsApiGetNodeAnalyticsRunApiV1TestRunsTestRunIdVersionsFlowVersionIdNodesNodeIdAnalyticsGetRequest, options?: RawAxiosRequestConfig) {
        return TestRunsApiFp(this.configuration).getNodeAnalyticsRunApiV1TestRunsTestRunIdVersionsFlowVersionIdNodesNodeIdAnalyticsGet(requestParameters.flowVersionId, requestParameters.testRunId, requestParameters.nodeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Test Run
     * @param {TestRunsApiGetTestRunRunApiV1TestRunsTestRunIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestRunsApi
     */
    public getTestRunRunApiV1TestRunsTestRunIdGet(requestParameters: TestRunsApiGetTestRunRunApiV1TestRunsTestRunIdGetRequest, options?: RawAxiosRequestConfig) {
        return TestRunsApiFp(this.configuration).getTestRunRunApiV1TestRunsTestRunIdGet(requestParameters.testRunId, options).then((request) => request(this.axios, this.basePath));
    }
}



